<template>
  <div id="login">
    <div class="container">
      <div class="loginBox">
        <div class="logo">

          <!-- <LogoSvg
            height="70px"
            style="color:#ffffff"
            alt="M Art"
          /> -->
          <span class="logo-icon"></span>
        </div>
        <!--   为了兼容默认填充    -->
        <input type="password" style="display: none;"/>
        <input type="text" autocomplete="off"  style="display: none;"/>

        <!-- <h1>M Art 道具馆</h1> -->
        <a-form
          id="components-form-demo-normal-login"
          :form="form"
          class="login-form"
          @submit="handleSubmit"
        >

          <a-form-item>
            <a-input
              v-decorator="[
                'phone',
                {
                  rules: [{ required: true, message: '手机号输入格式有误' , pattern: /^1[3456789]\d{9}$/ }],
                  validateTrigger: ['blur']
                }
              ]"
              placeholder="11位手机号"
            >

              <span class="phone-icon" slot="prefix"></span>
            </a-input>
          </a-form-item>
          <a-row type="flex" justify="space-between">
            <a-col span="15">
              <a-form-item aria-autocomplete="none">
                <a-input
                  autocomplete="new-password"
                  type="text"
                  v-decorator="[
                    'code',
                    {
                      rules: [{ required: true, message: '请输入验证码!' }]
                    }
                  ]"
                  placeholder="验证码"
                >
                  <span
                    slot="prefix"
                    class="chatCode"

                  ></span>
                </a-input>

              </a-form-item>
            </a-col>
            <a-col span="8">
              <a-button
                :disabled="codeState.sendBtn"
                :class="{'getCode-ing':codeState.isSend}"
                style="width: 100%; height:42px; border-radius:8px"
                v-text=" !codeState.isSend?'获取验证码': `${codeState.time}s`"
                @click.stop.prevent="getCode"
              >

              </a-button>
            </a-col>
          </a-row>

          <a-form-item>
            <a-input
              @change="passwordChange"
              autocomplete="new-password"
              v-decorator="[
                'psd',
                {
                  rules: [{ required: true, message: '至少6位密码，区分大小写' }, {min:6, message: '密码格式错误最少输入6位密码'}],
                  validateTrigger: ['blur']
                }
              ]"
              :type="exe1?'text':'password'"
              placeholder=" 密码"
            >
              <span @click="exe1 = !exe1" :class="[exe1?`exe_open`:`exe_close`]" slot="suffix" type="user" />
              <span class="pwd-icon" slot="prefix"></span>
            </a-input>
          </a-form-item>
          <a-form-item>
            <a-input
              autocomplete="false"
              @change="passwordChange"
              v-decorator="[
                'confirm_password',
                {
                  rules: [
                    { required: true, message: '请填写确认密码!'},
                    {validator: compareToFirstPassword}],
                  validateTrigger: ['blur']
                }
              ]"
              :type="exe2?'text':'password'"
              placeholder="确定密码"
            >
              <span @click="exe2 = !exe2" :class="[exe2?`exe_open`:`exe_close`]" slot="suffix" type="user" />
              <span class="pwd-icon" slot="prefix"></span>
            </a-input>
          </a-form-item>
          <a-button
            type="primary"
            @click="checkForm"
            class="login-form-button"
            style="width: 100%;height: 50px;border-radius:8px"
          >
            注册
          </a-button>
          <div style="text-align:center;margin-top:10px">
            <a-button type="link" @click="goLogin">已有账号？去登录</a-button>
          </div>
        </a-form>

      </div>
    </div>
    <a-modal
      class="agree-modal"
      v-model="showAgree"
      @cancel="closeAgree"
      :destroy-on-close="true"
      :footer="null"
      width="760px"
      centered
    >
      <span class="close-modal-icon" slot="closeIcon"></span>
      <div class="title" slot="title">{{ activeAgree === 1 ? '用户协议': '隐私协议' }}</div>
      <div class="agree-content">
        <div v-if="activeAgree === 1">
          <div>
            <p
              style="line-height:25pt; margin:0pt 0pt 10pt; orphans:0; text-align:center; text-indent:21pt; widows:0"
            >
              <span
                style="font-family:微软雅黑; font-size:12pt; font-weight:bold"
              >M Art</span
              ><span
                style="font-family:微软雅黑; font-size:12pt; font-weight:bold"
              >平台服务协议</span
              >
            </p>
            <p
              style="line-height:25pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0"
            >
              <span
                style="font-family:微软雅黑; font-size:12pt"
              >首部及导言</span
              >
            </p>
            <p
              style="line-height:25pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0"
            >
              <span
                style="font-family:微软雅黑; font-size:12pt"
              >欢迎您使用</span
              ><span style="font-family:微软雅黑; font-size:12pt">M Art</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >平台提供的服务！</span
              >
            </p>
            <p
              style="line-height:25pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0"
            >
              <span style="font-family:微软雅黑; font-size:12pt">为使用</span
              ><span style="font-family:微软雅黑; font-size:12pt">M Art</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >平台服务（以下简称：本服务），您应当阅读并遵守本《服务协议》（以下简称</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >:本协议）以及</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >平台公示的相关规则</span
              ><span style="font-family:微软雅黑; font-size:12pt">等</span
              ><span style="font-family:微软雅黑; font-size:12pt">法律文件</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >。请您务必审慎阅读、充分理解各条款内容，特别是免除或者限制责任的条款，以及开通或使用某项服务的单独协议、规则。
                除非您已阅读并接受本协议及相关协</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >议、规则等所有条款，否则，您无权使用</span
              ><span style="font-family:微软雅黑; font-size:12pt">M Art</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >提供的本服务。您使用</span
              ><span style="font-family:微软雅黑; font-size:12pt">M Art</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >的本服务，即视为您已阅读并同意上述协议、规则等的约束。您有违反本协议的任何行为时，</span
              ><span style="font-family:微软雅黑; font-size:12pt">M Art</span
              ><span style="font-family:微软雅黑; font-size:12pt">有权依</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >照违反情况，随时单方限制、中止或终止向您提供本服务，并有权追究您的相关责任。</span
              ><span style="font-family:微软雅黑; font-size:12pt"> </span>
            </p>
            <p
              style="line-height:25pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0"
            >
              <span
                style="font-family:微软雅黑; font-size:12pt"
              >如果您未满</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >18周岁，请在法定监护人的陪同下阅读本协议，并特别注意未成年人使用条款</span
              >
            </p>
            <p
              style="line-height:25pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0"
            >
              <span
                style="font-family:微软雅黑; font-size:12pt"
              >1.术语含义</span
              >
            </p>
            <p
              style="line-height:25pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0"
            >
              <span
                style="font-family:微软雅黑; font-size:12pt"
              >如无特别说明，下列术语在本协议中的含义为：</span
              >
            </p>
            <p
              style="line-height:25pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0"
            >
              <span style="font-family:微软雅黑; font-size:12pt">1.1</span
              ><span style="font-family:微软雅黑; font-size:12pt">M Art</span
              ><span style="font-family:微软雅黑; font-size:12pt">： 是指</span
              ><span style="font-family:微软雅黑; font-size:12pt">M Art</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >公司及其相关服务可能存在的运营关联单位。
              </span>
            </p>
            <p
              style="line-height:25pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0"
            >
              <span
                style="font-family:微软雅黑; font-size:12pt"
              >1.2投稿人：指经有效注册、申请后，通过</span
              ><span style="font-family:微软雅黑; font-size:12pt">M Art</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >平台上传原创或经权利人授权的作品供用户下载使用的个人、法人或其他组织，也简称为“您”。
              </span>
            </p>
            <p
              style="line-height:25pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0"
            >
              <span
                style="font-family:微软雅黑; font-size:12pt"
              >1.3授权人：指拥有作品著作权并授权投稿人通过</span
              ><span style="font-family:微软雅黑; font-size:12pt">M Art</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >平台上传该作品的个人、法人或其他组织。
              </span>
            </p>
            <p
              style="line-height:25pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0"
            >
              <span
                style="font-family:微软雅黑; font-size:12pt"
              >1.4普通用户：指拥有作品著作权并授权投稿人通过</span
              ><span style="font-family:微软雅黑; font-size:12pt">M Art</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >平台上传该作品的个人、法人或其他组织。
              </span>
            </p>
            <p
              style="line-height:25pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0"
            >
              <span
                style="font-family:微软雅黑; font-size:12pt"
              >1.5作品：指您或者授权人独立创作的、通过</span
              ><span style="font-family:微软雅黑; font-size:12pt">M Art</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >平台上传的原创内容，以及创作过程产生的全部资料、素材（包括但不限于每一幅</span
              ><span style="font-family:微软雅黑; font-size:12pt">图片</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >的标题、故事大纲、脚本/台词、角色关系、人物形象、服饰造型、场景等）。</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >本平台中常见的</span
              ><span style="font-family:微软雅黑; font-size:12pt">作品的</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >主要指平面美术作品和摄影作品</span
              ><span style="font-family:微软雅黑; font-size:12pt">等。</span>
            </p>
            <p
              style="line-height:25pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0"
            >
              <span style="font-family:微软雅黑; font-size:12pt">（</span
              ><span style="font-family:微软雅黑; font-size:12pt">1）</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >平面美术作品</span
              ><span style="font-family:微软雅黑; font-size:12pt">：</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >是指绘画、书法等以线条、色彩或者其他方式构成的平面艺术作品。</span
              >
            </p>
            <p
              style="line-height:25pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0"
            >
              <span style="font-family:微软雅黑; font-size:12pt">（</span
              ><span style="font-family:微软雅黑; font-size:12pt">2）</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >摄影作品：通过摄影师或业余爱好者通过灵感，摄影技术等对自然、人物等客观事物进行描绘、供人欣赏的艺术作品。</span
              >
            </p>
            <p
              style="line-height:25pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0"
            >
              <span style="font-family:微软雅黑; font-size:12pt">1.6</span
              ><span style="font-family:微软雅黑; font-size:12pt">M Art</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >平台：指由</span
              ><span style="font-family:微软雅黑; font-size:12pt">M Art</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >所拥有、控制、经营的</span
              ><span style="font-family:微软雅黑; font-size:12pt">M Art</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >平台网站及该网站的下属子页面、APP及H5站等，以下也简称为“</span
              ><span style="font-family:微软雅黑; font-size:12pt">M Art</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >平台”、“平台”。</span
              >
            </p>
            <p
              style="line-height:25pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0"
            >
              <span style="font-family:微软雅黑; font-size:12pt">M Art</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >、投稿人均同意和理解：</span
              >
            </p>
            <p
              style="line-height:25pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0"
            >
              <span style="font-family:微软雅黑; font-size:12pt">（</span
              ><span style="font-family:微软雅黑; font-size:12pt">1）</span
              ><span style="font-family:微软雅黑; font-size:12pt">M Art</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >平台作为一个中立的平台，本协议项下仅向投稿人及用户提供作品上传</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >、文化经营</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >服务或相关中立的技术支持服务；</span
              ><span
                style="font-family:微软雅黑; font-size:12pt; text-decoration:underline"
              >M Art</span
              ><span
                style="font-family:微软雅黑; font-size:12pt; text-decoration:underline"
              >平台也不提供编辑、加工、汇编、翻译等出版服务</span
              ><span style="font-family:微软雅黑; font-size:12pt">；</span>
            </p>
            <p
              style="line-height:25pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0"
            >
              <span style="font-family:微软雅黑; font-size:12pt">（</span
              ><span style="font-family:微软雅黑; font-size:12pt">2）</span
              ><span
                style="font-family:微软雅黑; font-size:12pt; font-weight:bold; text-decoration:underline"
              >用户</span
              ><span
                style="font-family:微软雅黑; font-size:12pt; font-weight:bold; text-decoration:underline"
              >的作品由</span
              ><span
                style="font-family:微软雅黑; font-size:12pt; font-weight:bold; text-decoration:underline"
              >用户</span
              ><span
                style="font-family:微软雅黑; font-size:12pt; font-weight:bold; text-decoration:underline"
              >或授权人自主创作</span
              ><span
                style="font-family:微软雅黑; font-size:12pt; font-weight:bold; text-decoration:underline"
              >、自主删改、自愿上传、拥有知识产权</span
              ><span
                style="font-family:微软雅黑; font-size:12pt; font-weight:bold; text-decoration:underline"
              >并独立承担全部责任</span
              ><span style="font-family:微软雅黑; font-size:12pt">；</span
              ><span style="font-family:微软雅黑; font-size:12pt">用户与</span
              ><span style="font-family:微软雅黑; font-size:12pt">M Art</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >另行签署书面协议转让其作品著作权的，按照协议约定明确双方的权利和义务。</span
              >
            </p>
            <p
              style="line-height:25pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0"
            >
              <span style="font-family:微软雅黑; font-size:12pt">（</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >3）因投稿人的作品产生的任何纠纷、责任等，以及投稿人违反相关法律法规或本协议约定引发的任何后果，均由投稿人独立承担责任、赔偿损失，与</span
              ><span style="font-family:微软雅黑; font-size:12pt">M Art</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >无关。如侵害到</span
              ><span style="font-family:微软雅黑; font-size:12pt">M Art</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >或他人权益的，投稿人须自行承担全部责任和赔偿一切损失。
              </span>
            </p>
            <p
              style="line-height:25pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0"
            >
              <span style="font-family:微软雅黑; font-size:12pt">1.7</span
              ><span style="font-family:微软雅黑; font-size:12pt">M Art</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >平台运营数据：指用户、投稿人在使用</span
              ><span style="font-family:微软雅黑; font-size:12pt">M Art</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >平台服务中产生的相关数据，包括但不限于用户或投稿人提交的数据、操作行为形成的数据及各类交易数据等。“</span
              ><span style="font-family:微软雅黑; font-size:12pt">M Art</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >平台运营数据”的所有权及其他相关权利属于</span
              ><span style="font-family:微软雅黑; font-size:12pt">M Art</span
              ><span style="font-family:微软雅黑; font-size:12pt">，且是</span
              ><span style="font-family:微软雅黑; font-size:12pt">M Art</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >的商业秘密，依法属于用户享有的相关权利除外。
              </span>
            </p>
            <p
              style="line-height:25pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0"
            >
              <span
                style="font-family:微软雅黑; font-size:12pt"
              >2.投稿人的权利和义务</span
              >
            </p>
            <p
              style="line-height:25pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0"
            >
              <span
                style="font-family:微软雅黑; font-size:12pt"
              >2.1帐户注册
              </span>
            </p>
            <p
              style="line-height:25pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0"
            >
              <span
                style="font-family:微软雅黑; font-size:12pt"
              >2.1.1投稿人应当通过登录</span
              ><span style="font-family:微软雅黑; font-size:12pt">M Art</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >平台网站或</span
              ><span style="font-family:微软雅黑; font-size:12pt">M Art</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >其他指定途径，使用官方指定方式注册投稿人帐户（以下简称：帐户）以成为投稿人，投稿人帐户一经注册成功，相应的账号信息不得变更，且该帐户不可转让、不可赠与、不可继承等。
              </span>
            </p>
            <p
              style="line-height:25pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0"
            >
              <span
                style="font-family:微软雅黑; font-size:12pt"
              >2.1.2您注册帐号时，应使用您拥有合法使用权的账号信息，并遵守相关协议、规则等的约束。
              </span>
            </p>
            <p
              style="line-height:25pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0"
            >
              <span
                style="font-family:微软雅黑; font-size:12pt"
              >2.1.3您不得违反本协议约定将您的帐户用于其他目的。否则，</span
              ><span style="font-family:微软雅黑; font-size:12pt">M Art</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >有权随时单方限制、中止或终止向您提供本服务，且未经</span
              ><span style="font-family:微软雅黑; font-size:12pt">M Art</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >同意您不得再次使用本服务。
              </span>
            </p>
            <p
              style="line-height:25pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0"
            >
              <span
                style="font-family:微软雅黑; font-size:12pt"
              >2.1.4您注册帐号使用的注册信息是您登录及使用本服务的凭证。您应当做好帐号、密码以及进入和管理本服务中的各类功能与服务的口令、密码等的保密措施。因您保密措施不当或您的其他行为，致使上述口令、密码等丢失或泄漏所引起的一切损失和后果，均由您自行承担。
              </span>
            </p>
            <p
              style="line-height:25pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0"
            >
              <span
                style="font-family:微软雅黑; font-size:12pt"
              >2.1.5您保证：您注册本服务帐户时提供和使用的所有个人信息是合法的。前述账号信息在本服务中进行的包括但不限于以下事项：注册本服务帐户、提交相应资质材料、确认和同意相关协议和规则等事项，均是您自行或您授权他人进行的行为，对您均有约束力。同时，您承担以前述账号信息为标识进行的全部行为的法律责任。
              </span>
            </p>
            <p
              style="line-height:25pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0"
            >
              <span
                style="font-family:微软雅黑; font-size:12pt"
              >2.1.6若您发现有他人冒用或盗用您的帐户及密码、或任何其他未经您合法授权的情形时，应立即以有效方式通知</span
              ><span style="font-family:微软雅黑; font-size:12pt">M Art</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >（包括但不限于提供您的身份信息和相关身份资料、相关事实情况及您的要求等）。</span
              ><span style="font-family:微软雅黑; font-size:12pt">M Art</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >收到您的有效请求并核实身份后，会根据不同情况采取相应措施。若您提供的信息不完全，导致</span
              ><span style="font-family:微软雅黑; font-size:12pt">M Art</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >无法核实您的身份或</span
              ><span style="font-family:微软雅黑; font-size:12pt">M Art</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >无法判断您的需求等，而导致</span
              ><span style="font-family:微软雅黑; font-size:12pt">M Art</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >无法进行及时处理，给您带来的损失，您应自行承担。同时，</span
              ><span style="font-family:微软雅黑; font-size:12pt">M Art</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >对您的请求采取措施需要合理期限，在您通知</span
              ><span style="font-family:微软雅黑; font-size:12pt">M Art</span
              ><span style="font-family:微软雅黑; font-size:12pt">以及</span
              ><span style="font-family:微软雅黑; font-size:12pt">M Art</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >根据您的有效通知采取措施之前，由于他人行为给您造成的损失，</span
              ><span style="font-family:微软雅黑; font-size:12pt">M Art</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >不承担任何责任</span
              ><span style="font-family:微软雅黑; font-size:12pt">。</span
              ><span style="font-family:微软雅黑; font-size:12pt"> </span>
            </p>
            <p
              style="line-height:25pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0"
            >
              <span
                style="font-family:微软雅黑; font-size:12pt"
              >2.2资质材料
              </span>
            </p>
            <p
              style="line-height:25pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0"
            >
              <span
                style="font-family:微软雅黑; font-size:12pt"
              >2.2.1您保证：您如实填写和提交帐号注册与您审核资料，并对资料的真实性、合法性、准确性和有效性承担责任；您提供的主体资质材料、相关资质证明以及其他任何文件等信息真实、准确、完整，并在信息发生变更后，及时进行更新；您具备履行本协议项下之义务、各种行为的能力；您履行相关义务、从事相关行为不违反任何对您有约束力的法律文件。否则，</span
              ><span style="font-family:微软雅黑; font-size:12pt">M Art</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >有权拒绝或终止提供本服务，并依照本协议对违规帐号进行处罚，您应独自承担由此带来的一切责任及给第三方、</span
              ><span style="font-family:微软雅黑; font-size:12pt">M Art</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >造成的全部损失。
              </span>
            </p>
            <p
              style="line-height:25pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0"
            >
              <span
                style="font-family:微软雅黑; font-size:12pt"
              >2.2.2您保证：您对在</span
              ><span style="font-family:微软雅黑; font-size:12pt">M Art</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >平台上传的作品拥有著作权或已经著作权人授权，</span
              ><span style="font-family:微软雅黑; font-size:12pt">M Art</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >有权要求您提供相关权利证明文件、授权文件、相关机构颁发的权利证书等，您应当配合。
              </span>
            </p>
            <p
              style="line-height:25pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0"
            >
              <span
                style="font-family:微软雅黑; font-size:12pt"
              >2.2.3您保证：您在</span
              ><span style="font-family:微软雅黑; font-size:12pt">M Art</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >平台上传的作品，符合国家相关法规的规定，不违反任何相关法规及相关协议、规则，也不会侵犯任何人的合法权益，同时，</span
              ><span style="font-family:微软雅黑; font-size:12pt">M Art</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >有权要求您提供相关权利证明文件、授权文件、相关机构颁发的权利证书等，您应当配合。
              </span>
            </p>
            <p
              style="line-height:25pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0"
            >
              <span
                style="font-family:微软雅黑; font-size:12pt"
              >2.2.4您保证：您会依法及按照</span
              ><span style="font-family:微软雅黑; font-size:12pt">M Art</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >要求提交使用本服务所必须的真实、准确的主体资质材料以及联系人姓名（名称）、地址、电子邮箱等相关资料。
              </span>
            </p>
            <p
              style="line-height:25pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0"
            >
              <span
                style="font-family:微软雅黑; font-size:12pt"
              >2.3投稿人资质审核
              </span>
            </p>
            <p
              style="line-height:25pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0"
            >
              <span style="font-family:微软雅黑; font-size:12pt">2.3.1</span
              ><span style="font-family:微软雅黑; font-size:12pt">M Art</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >仅对您提交的资料和信息进行审核，并不对您实际行为承担任何责任或提供任何担保。因您的行为导致与其他用户或第三方发生争议的，由您独立对外承担责任，因此给</span
              ><span style="font-family:微软雅黑; font-size:12pt">M Art</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >、其他用户或第三方造成损害的，您应当依法予以赔偿。
              </span>
            </p>
            <p
              style="line-height:25pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0"
            >
              <span
                style="font-family:微软雅黑; font-size:12pt"
              >2.3.2为向用户提供更专业的服务，您同意授权</span
              ><span style="font-family:微软雅黑; font-size:12pt">M Art</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >可以委托第三方对投稿人所提交的资料进行审核，并根据审核情况进行独立判断后确定审核结果。
              </span>
            </p>
            <p
              style="line-height:25pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0"
            >
              <span
                style="font-family:微软雅黑; font-size:12pt"
              >2.4作品要求
              </span>
            </p>
            <p
              style="line-height:25pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0"
            >
              <span
                style="font-family:微软雅黑; font-size:12pt"
              >2.4.1投稿人应当自行负责您作品的创作、上传及</span
              ><span style="font-family:微软雅黑; font-size:12pt">素材交易</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >等工作。
              </span>
            </p>
            <p
              style="line-height:25pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0"
            >
              <span
                style="font-family:微软雅黑; font-size:12pt"
              >2.4.2投稿人的作品，应符合相关法规、规范或标准等，同时，还应符合</span
              ><span style="font-family:微软雅黑; font-size:12pt">M Art</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >平台的对作品制作与上传等方面的统一要求，如《</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              ><a style="color:blue" @click="active = '4'">创作规范</a> </span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >》及其他相关规则。
              </span>
            </p>
            <p
              style="line-height:25pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0"
            >
              <span
                style="font-family:微软雅黑; font-size:12pt"
              >2.4.3投稿人的作品不应侵犯任何人的合法权益，包括但不限于著作权、商标权、肖像权、名誉权、姓名权等。
              </span>
            </p>
            <p
              style="line-height:25pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0"
            >
              <span
                style="font-family:微软雅黑; font-size:12pt"
              >2.4.4基于维护</span
              ><span style="font-family:微软雅黑; font-size:12pt">M Art</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >平台其他用户的合法权益以及保障作品发布、阅读的稳定性，如果您考虑下架您自行上传的作品，应当提前以有效方式通知</span
              ><span style="font-family:微软雅黑; font-size:12pt">M Art</span
              ><span style="font-family:微软雅黑; font-size:12pt">，并与</span
              ><span style="font-family:微软雅黑; font-size:12pt">M Art</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >共同友好商议处理方案。若您违反上述约定擅自下架作品，则由此导致的用户投诉、争议等，应当由您自行承担责任并独立解决；若给</span
              ><span style="font-family:微软雅黑; font-size:12pt">M Art</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >造成相应损失的，还应当负责赔偿。同时，</span
              ><span style="font-family:微软雅黑; font-size:12pt">M Art</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >还有权要求您退还基于使用</span
              ><span style="font-family:微软雅黑; font-size:12pt">M Art</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >平台服务取得的全部收益。若您与</span
              ><span style="font-family:微软雅黑; font-size:12pt">M Art</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >另行签署其他相关书面协议，则以该书面协议的约定为准。
              </span>
            </p>
            <p
              style="line-height:25pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0"
            >
              <span style="font-family:微软雅黑; font-size:12pt">2.5</span
              ><span style="font-family:微软雅黑; font-size:12pt">上传、</span
              ><span style="font-family:微软雅黑; font-size:12pt">作品</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >展示、素材交易等行为</span
              ><span style="font-family:微软雅黑; font-size:12pt"> </span>
            </p>
            <p
              style="line-height:25pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0"
            >
              <span
                style="font-family:微软雅黑; font-size:12pt"
              >2.5.1您应自行按照相关法规，</span
              ><span style="font-family:微软雅黑; font-size:12pt">上传</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >您的作品，履行相关义务，并自行承担全部责任，包括但不限于：
              </span>
            </p>
            <p
              style="line-height:25pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0"
            >
              <span style="font-family:微软雅黑; font-size:12pt">（</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >1）依照相关法律法规的规定，规范线上线下作品的</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >创作、上传、素材交易等</span
              ><span style="font-family:微软雅黑; font-size:12pt">行为； </span>
            </p>
            <p
              style="line-height:25pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0"
            >
              <span style="font-family:微软雅黑; font-size:12pt">（</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >2）国家有权机关向您依法查询相关信息时，应积极配合提供；</span
              >
            </p>
            <p
              style="line-height:25pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0"
            >
              <span style="font-family:微软雅黑; font-size:12pt">（</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >3）您应依法主动履行的其他义务。
              </span>
            </p>
            <p
              style="line-height:25pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0"
            >
              <span
                style="font-family:微软雅黑; font-size:12pt"
              >2.5.2您不得从事任何包括但不限于以下违规行为，也不得为以下违规行为提供便利：
              </span>
            </p>
            <p
              style="line-height:25pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0"
            >
              <span style="font-family:微软雅黑; font-size:12pt">（</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >1）反对宪法所确定的基本原则的行为；
              </span>
            </p>
            <p
              style="line-height:25pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0"
            >
              <span style="font-family:微软雅黑; font-size:12pt">（</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >2）危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的行为；
              </span>
            </p>
            <p
              style="line-height:25pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0"
            >
              <span style="font-family:微软雅黑; font-size:12pt">（</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >3）损害国家荣誉和利益的行为；
              </span>
            </p>
            <p
              style="line-height:25pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0"
            >
              <span style="font-family:微软雅黑; font-size:12pt">（</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >4）煽动民族仇恨、民族歧视，破坏民族团结的行为；
              </span>
            </p>
            <p
              style="line-height:25pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0"
            >
              <span style="font-family:微软雅黑; font-size:12pt">（</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >5）破坏国家宗教政策，宣扬邪教和封建迷信的行为；
              </span>
            </p>
            <p
              style="line-height:25pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0"
            >
              <span style="font-family:微软雅黑; font-size:12pt">（</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >6）散布谣言，扰乱社会秩序，破坏社会稳定的行为；
              </span>
            </p>
            <p
              style="line-height:25pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0"
            >
              <span style="font-family:微软雅黑; font-size:12pt">（</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >7）散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的行为；
              </span>
            </p>
            <p
              style="line-height:25pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0"
            >
              <span style="font-family:微软雅黑; font-size:12pt">（</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >8）侮辱或者诽谤他人，侵害他人合法权益的行为；
              </span>
            </p>
            <p
              style="line-height:25pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0"
            >
              <span style="font-family:微软雅黑; font-size:12pt">（</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >9）侵害他人知识产权、商业秘密等合法权利的行为；
              </span>
            </p>
            <p
              style="line-height:25pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0"
            >
              <span style="font-family:微软雅黑; font-size:12pt">（</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >10）恶意虚构事实、隐瞒真相以误导、欺骗他人的行为；
              </span>
            </p>
            <p
              style="line-height:25pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0"
            >
              <span style="font-family:微软雅黑; font-size:12pt">（</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >11）发布、传送、传播广告信息及垃圾信息；
              </span>
            </p>
            <p
              style="line-height:25pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0"
            >
              <span style="font-family:微软雅黑; font-size:12pt">（</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >12）其他法律法规禁止的行为。
              </span>
            </p>
            <p
              style="line-height:25pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0"
            >
              <span
                style="font-family:微软雅黑; font-size:12pt"
              >2.5.3您不得从事包括但不限于以下行为，也不得为以下行为提供便利：
              </span>
            </p>
            <p
              style="line-height:25pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0"
            >
              <span style="font-family:微软雅黑; font-size:12pt">（</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >1）删除、隐匿、改变</span
              ><span style="font-family:微软雅黑; font-size:12pt">M Art</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >平台显示或其中包含的任何专利、著作权、商标或其他所有权声明；
              </span>
            </p>
            <p
              style="line-height:25pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0"
            >
              <span style="font-family:微软雅黑; font-size:12pt">（</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >2）以任何方式干扰或企图干扰</span
              ><span style="font-family:微软雅黑; font-size:12pt">M Art</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >任何产品、任何部分或功能的正常运行，或者制作、发布、传播上述工具、方法等；
              </span>
            </p>
            <p
              style="line-height:25pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0"
            >
              <span style="font-family:微软雅黑; font-size:12pt">（</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >3）避开、尝试避开或声称能够避开任何内容保护机制，或导致用户认为其直接与</span
              ><span style="font-family:微软雅黑; font-size:12pt">M Art</span
              ><span style="font-family:微软雅黑; font-size:12pt">平台及</span
              ><span style="font-family:微软雅黑; font-size:12pt">M Art</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >相关产品进行交互；
              </span>
            </p>
            <p
              style="line-height:25pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0"
            >
              <span style="font-family:微软雅黑; font-size:12pt">（</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >4）在未获得</span
              ><span style="font-family:微软雅黑; font-size:12pt">M Art</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >书面许可的情况下，以任何方式使用</span
              ><span style="font-family:微软雅黑; font-size:12pt">M Art</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >URL地址、技术接口等；</span
              >
            </p>
            <p
              style="line-height:25pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0"
            >
              <span style="font-family:微软雅黑; font-size:12pt">（</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >5）在未经过用户同意的情况下，向任何其他用户及他方显示或以其他任何方式提供该用户的任何信息；
              </span>
            </p>
            <p
              style="line-height:25pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0"
            >
              <span style="font-family:微软雅黑; font-size:12pt">（</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >6）在未获得</span
              ><span style="font-family:微软雅黑; font-size:12pt">M Art</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >书面许可的情况下，请求、收集、索取或以其他方式获取用户</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >关于本平台的账号，以及</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >QQ、微信等帐号、密码或其他任何身份验证凭据；
              </span>
            </p>
            <p
              style="line-height:25pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0"
            >
              <span style="font-family:微软雅黑; font-size:12pt">（</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >7）为任何用户自动登录到</span
              ><span style="font-family:微软雅黑; font-size:12pt">M Art</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >平台提供代理身份验证凭据；
              </span>
            </p>
            <p
              style="line-height:25pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0"
            >
              <span style="font-family:微软雅黑; font-size:12pt">（</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >8）提供跟踪功能，包括但不限于识别其他用户在个人主页上查看、点击等操作行为；
              </span>
            </p>
            <p
              style="line-height:25pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0"
            >
              <span style="font-family:微软雅黑; font-size:12pt">（</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >9）自动将浏览器窗口定向到其他网页；
              </span>
            </p>
            <p
              style="line-height:25pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0"
            >
              <span style="font-family:微软雅黑; font-size:12pt">（</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >10）未经授权获取对</span
              ><span style="font-family:微软雅黑; font-size:12pt">M Art</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >产品或服务的访问权；
              </span>
            </p>
            <p
              style="line-height:25pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0"
            >
              <span style="font-family:微软雅黑; font-size:12pt">（</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >11）应用中含有计算机病毒、木马或其他恶意程序等任何可能危害</span
              ><span style="font-family:微软雅黑; font-size:12pt">M Art</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >或用户权益和终端信息安全等的内容；
              </span>
            </p>
            <p
              style="line-height:25pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0"
            >
              <span style="font-family:微软雅黑; font-size:12pt">（</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >12）设置或发布任何违反相关法规、公序良俗、社会公德等的功能或内容等；
              </span>
            </p>
            <p
              style="line-height:25pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0"
            >
              <span style="font-family:微软雅黑; font-size:12pt">（</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >13）公开表达或暗示，您与</span
              ><span style="font-family:微软雅黑; font-size:12pt">M Art</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >之间存在合作关系，包括但不限于相互持股、商业往来或合作关系等，或声称</span
              ><span style="font-family:微软雅黑; font-size:12pt">M Art</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >对您的认可；
              </span>
            </p>
            <p
              style="line-height:25pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0"
            >
              <span style="font-family:微软雅黑; font-size:12pt">（</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >14）填写和提交帐号注册与投稿人审核资料违反本协议规定，或申请投稿人审核资料与注册信息内容不一致，以及运营行为与注册或投稿人认证信息所公示身份无关的；
              </span>
            </p>
            <p
              style="line-height:25pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0"
            >
              <span style="font-family:微软雅黑; font-size:12pt">（</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >15）若您确认上传的作品性质为“独家”，则在未获得</span
              ><span style="font-family:微软雅黑; font-size:12pt">M Art</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >书面许可的情况下，您不得将发表于</span
              ><span style="font-family:微软雅黑; font-size:12pt">M Art</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >平台的作品在其他第三方网站、平台发表；
              </span>
            </p>
            <p
              style="line-height:25pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0"
            >
              <span style="font-family:微软雅黑; font-size:12pt">（</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >16）公开表达或暗示，宣传第三方动漫网站、应用、产品或其他未经</span
              ><span style="font-family:微软雅黑; font-size:12pt">M Art</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >授权之个人、企业、工作室等的任何内容（包括但不限于商标、Logo、企业字号、作者/作品信息等）；
              </span>
            </p>
            <p
              style="line-height:25pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0"
            >
              <span style="font-family:微软雅黑; font-size:12pt">（</span
              ><span style="font-family:微软雅黑; font-size:12pt">17）其他</span
              ><span style="font-family:微软雅黑; font-size:12pt">M Art</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >认为不应该、不适当的行为、内容。本服务中可能会使用第三方软件或技术，若有使用，</span
              ><span style="font-family:微软雅黑; font-size:12pt">M Art</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >保证已经获得合法授权，同时，</span
              ><span style="font-family:微软雅黑; font-size:12pt">M Art</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >将按照相关法规或约定，对相关的协议或其他文件，进行展示。前述通过各种形式展现的相关协议或其他文件，均是本协议不可分割的组成部分，与本协议具有同等的法律效力，您应当遵守这些要求。否则，因此带来的一切责任您应自行承担。如因本服务使用的第三方软件或技术引发的任何纠纷，由该第三方负责解决。
              </span>
            </p>
            <p
              style="line-height:25pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0"
            >
              <span
                style="font-family:微软雅黑; font-size:12pt"
              >2.6关于用户数据的规则
              </span>
            </p>
            <p
              style="line-height:25pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0"
            >
              <span
                style="font-family:微软雅黑; font-size:12pt"
              >2.6.1在未获得其他用户同意的情况下，您不得收集用户的隐私信息数据及其他</span
              ><span style="font-family:微软雅黑; font-size:12pt">M Art</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >认为属于敏感信息范畴的数据，包括但不限于不得收集或要求用户提供任何</span
              ><span style="font-family:微软雅黑; font-size:12pt">账号</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >、密码、用户关系链、好友列表数据、银行账号和密码等。基于本款约定产生的法律责任，由您自行向其他用户或其他主体承担。
              </span>
            </p>
            <p
              style="line-height:25pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0"
            >
              <span style="font-family:微软雅黑; font-size:12pt">2.6.2</span
              ><span style="font-family:微软雅黑; font-size:12pt">M Art</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >有权限制或阻止您获取用户数据及</span
              ><span style="font-family:微软雅黑; font-size:12pt">M Art</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >平台数据。
              </span>
            </p>
            <p
              style="line-height:25pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0"
            >
              <span style="font-family:微软雅黑; font-size:12pt">2.6.3</span
              ><span style="font-family:微软雅黑; font-size:12pt">M Art</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >平台运营数据、用户数据等数据的全部权利，均归属</span
              ><span style="font-family:微软雅黑; font-size:12pt">M Art</span
              ><span style="font-family:微软雅黑; font-size:12pt">，且是</span
              ><span style="font-family:微软雅黑; font-size:12pt">M Art</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >的商业秘密，依法属于用户享有的相关权利除外。未经</span
              ><span style="font-family:微软雅黑; font-size:12pt">M Art</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >事先书面同意，您不得为本协议约定之外的目的使用前述数据，亦不得以任何形式将前述数据提供给他人。
              </span>
            </p>
            <p
              style="line-height:25pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0"
            >
              <span
                style="font-family:微软雅黑; font-size:12pt"
              >2.6.4一旦您停止使用本服务，或停止使用</span
              ><span style="font-family:微软雅黑; font-size:12pt">M Art</span
              ><span style="font-family:微软雅黑; font-size:12pt">平台，或</span
              ><span style="font-family:微软雅黑; font-size:12pt">M Art</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >基于任何原因终止您使用本服务，您必须立即删除全部从</span
              ><span style="font-family:微软雅黑; font-size:12pt">M Art</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >平台中获得的数据（包括各种备份），且不得再以任何方式进行使用。您理解并同意，本款约定情况下不得擅自下架作品。基于维护</span
              ><span style="font-family:微软雅黑; font-size:12pt">M Art</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >平台其他用户的合法权益以及保障作品发布、阅读的稳定性，您应当与</span
              ><span style="font-family:微软雅黑; font-size:12pt">M Art</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >共同友好商议处理方案；且除您与</span
              ><span style="font-family:微软雅黑; font-size:12pt">M Art</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >达成一致意见外，您基于本款约定停止使用本服务的情况下，不影响已发布作品在</span
              ><span style="font-family:微软雅黑; font-size:12pt">M Art</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >平台的继续连载、使用，且不视为</span
              ><span style="font-family:微软雅黑; font-size:12pt">M Art</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >侵权。若由此导致其他用户的投诉等，应当由您自行承担</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >责任并独立解决；若给</span
              ><span style="font-family:微软雅黑; font-size:12pt">M Art</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >造成相应损失的，还应当负责赔偿。同时，</span
              ><span style="font-family:微软雅黑; font-size:12pt">M Art</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >还有权要求您退还基于使用</span
              ><span style="font-family:微软雅黑; font-size:12pt">M Art</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >平台服务取得的全部收益。若您与</span
              ><span style="font-family:微软雅黑; font-size:12pt">M Art</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >另行签署其他相关书面协议，则以该书面协议的约定为准。</span
              ><span style="font-family:微软雅黑; font-size:12pt"> </span>
            </p>
            <p
              style="line-height:25pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0"
            >
              <span
                style="font-family:微软雅黑; font-size:12pt"
              >2.6.5您应自行对因使用本服务而存储在</span
              ><span style="font-family:微软雅黑; font-size:12pt">M Art</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >服务器的各类数据等信息，在本服务之外，采取合理、安全的技术措施，确保其安全性，并对自己的行为（包括但不限于自行安装软件、采取加密措施或进行其他安全措施等）所引起的结果承担全部责任。
              </span>
            </p>
            <p
              style="line-height:25pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0"
            >
              <span
                style="font-family:微软雅黑; font-size:12pt"
              >2.7法律责任
              </span>
            </p>
            <p
              style="line-height:25pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0"
            >
              <span
                style="font-family:微软雅黑; font-size:12pt"
              >2.7.1您保证：您使用本服务及您的任何行为，不会侵犯任何人的合法权益等。
              </span>
            </p>
            <p
              style="line-height:25pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0"
            >
              <span
                style="font-family:微软雅黑; font-size:12pt"
              >2.7.2您理解并同意：若</span
              ><span style="font-family:微软雅黑; font-size:12pt">M Art</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >自行发现或根据相关部门的信息、权利人的投诉等发现您可能存在侵犯他人合法权益情形的，</span
              ><span style="font-family:微软雅黑; font-size:12pt">M Art</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >有权根据一般人的认识自己进行独立判断，以认定您是否存在侵犯他人合法权益情形，若</span
              ><span style="font-family:微软雅黑; font-size:12pt">M Art</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >经过判断认为您存在侵犯他人合法权益情形的，</span
              ><span style="font-family:微软雅黑; font-size:12pt">M Art</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >有权随时单方采取以下一项或多项措施：
              </span>
            </p>
            <p
              style="line-height:25pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0"
            >
              <span style="font-family:微软雅黑; font-size:12pt">（</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >1）要求您立即更换、修改前述侵权作品的相关内容；</span
              >
            </p>
            <p
              style="line-height:25pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0"
            >
              <span style="font-family:微软雅黑; font-size:12pt">（</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >2）对存在违反前述保证情形的部分或全部</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >作品内容章节</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >、图片或者您名下的</span
              ><span style="font-family:微软雅黑; font-size:12pt">其他</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >作品采取限制用户使用等措施；
              </span>
            </p>
            <p
              style="line-height:25pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0"
            >
              <span style="font-family:微软雅黑; font-size:12pt">（</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >3）对存在侵犯他人合法权益的作品采取下架措施，直至终止您使用</span
              ><span style="font-family:微软雅黑; font-size:12pt">M Art</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >平台的服务；
              </span>
            </p>
            <p
              style="line-height:25pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0"
            >
              <span style="font-family:微软雅黑; font-size:12pt">（</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >4）追究您的法律责任；
              </span>
            </p>
            <p
              style="line-height:25pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0"
            >
              <span style="font-family:微软雅黑; font-size:12pt">（</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >5）将您的行为对外予以公告；
              </span>
            </p>
            <p
              style="line-height:25pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0"
            >
              <span style="font-family:微软雅黑; font-size:12pt">（</span
              ><span style="font-family:微软雅黑; font-size:12pt">6）其他</span
              ><span style="font-family:微软雅黑; font-size:12pt">M Art</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >认为适合的处理措施。
              </span>
            </p>
            <p
              style="line-height:25pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0"
            >
              <span
                style="font-family:微软雅黑; font-size:12pt"
              >对于侵犯他人合法权益的作品，假设您对该作品进行修改后不再侵犯他人的合法权益，您同意</span
              ><span style="font-family:微软雅黑; font-size:12pt">M Art</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >仍然有权对修改后的作品进行下架处理。同时，若有需要，您可以将修改后的不再侵犯他人合法权益的作品作为新作品按照</span
              ><span style="font-family:微软雅黑; font-size:12pt">M Art</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >平台的流程、规范等重新向</span
              ><span style="font-family:微软雅黑; font-size:12pt">M Art</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >平台投稿。</span
              ><span style="font-family:微软雅黑; font-size:12pt"> </span>
            </p>
            <p
              style="line-height:25pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0"
            >
              <span
                style="font-family:微软雅黑; font-size:12pt"
              >2.7.3您保证：您使用本服务及您的任何行为，不违反任何相关法规、本协议和相关协议、规则等。否则，您理解并同意：若</span
              ><span style="font-family:微软雅黑; font-size:12pt">M Art</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >自行发现或根据相关部门的信息、权利人的投诉等发现您可能存在违反前述保证情形的，</span
              ><span style="font-family:微软雅黑; font-size:12pt">M Art</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >有权根据一般人的认识自己独立判断，以认定您是否存在违反前述保证情形，若</span
              ><span style="font-family:微软雅黑; font-size:12pt">M Art</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >经过判断认为您存在违反前述保证情形的，</span
              ><span style="font-family:微软雅黑; font-size:12pt">M Art</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >有权随时单方采取以下一项或多项措施。
              </span>
            </p>
            <p
              style="line-height:25pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0"
            >
              <span style="font-family:微软雅黑; font-size:12pt">（</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >1）要求您立即更换、修改违反前述保证情形的相关内容；
              </span>
            </p>
            <p
              style="line-height:25pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0"
            >
              <span style="font-family:微软雅黑; font-size:12pt">（</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >2）对存在违反前述保证情形的部分或全部</span
              ><span style="font-family:微软雅黑; font-size:12pt">作品内容</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >章节、图片或者您名下的全部作品采取限制用户使用等措施；
              </span>
            </p>
            <p
              style="line-height:25pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0"
            >
              <span style="font-family:微软雅黑; font-size:12pt">（</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >3）对存在侵犯他人合法权益的作品采取下架措施，直至终止您使用</span
              ><span style="font-family:微软雅黑; font-size:12pt">M Art</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >平台的服务；
              </span>
            </p>
            <p
              style="line-height:25pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0"
            >
              <span style="font-family:微软雅黑; font-size:12pt">（</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >4）禁止您今后将您的任何新作品上传至</span
              ><span style="font-family:微软雅黑; font-size:12pt">M Art</span
              ><span style="font-family:微软雅黑; font-size:12pt">平台； </span>
            </p>
            <p
              style="line-height:25pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0"
            >
              <span style="font-family:微软雅黑; font-size:12pt">（</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >5）追究您的法律责任；
              </span>
            </p>
            <p
              style="line-height:25pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0"
            >
              <span style="font-family:微软雅黑; font-size:12pt">（</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >6）将您的行为对外予以公告；
              </span>
            </p>
            <p
              style="line-height:25pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0"
            >
              <span style="font-family:微软雅黑; font-size:12pt">（</span
              ><span style="font-family:微软雅黑; font-size:12pt">7）其他</span
              ><span style="font-family:微软雅黑; font-size:12pt">M Art</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >认为适合的处理措施。
              </span>
            </p>
            <p
              style="line-height:25pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0"
            >
              <span style="font-family:微软雅黑; font-size:12pt">2.7.4若</span
              ><span style="font-family:微软雅黑; font-size:12pt">M Art</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >按照上述条款、本协议的其他相关约定或因您违反相关法律的规定，对您或您的作品采取任何行为或措施，所引起的纠纷、责任等一概由您自行负责，造成您损失的，您应自行全部承担，造成</span
              ><span style="font-family:微软雅黑; font-size:12pt">M Art</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >或他人损失的，您也应自行承担全部责任。
              </span>
            </p>
            <p
              style="line-height:25pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0"
            >
              <span
                style="font-family:微软雅黑; font-size:12pt"
              >3.普通用户的权利和义务</span
              >
            </p>
            <p
              style="line-height:25pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0"
            >
              <span
                style="font-family:微软雅黑; font-size:12pt"
              >3.1用户在注册帐号或使用本服务的过程中，可能需要填写一些必要的信息。若国家法律法规有特殊规定的，用户需要填写真实的身份信息。若用户填写的信息不完整，则无法使用本服务或在使用过程中受到限制。</span
              >
            </p>
            <p
              style="line-height:25pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0"
            >
              <span
                style="font-family:微软雅黑; font-size:12pt"
              >3.2一般情况下，用户可以随时浏览、修改自己提交的信息，但出于安全性和身份识别（如号码申诉服务）的考虑，用户可能无法修改注册时提供的初始注册信息及其他验证信息。
              </span>
            </p>
            <p
              style="line-height:25pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0"
            >
              <span
                style="font-family:微软雅黑; font-size:12pt"
              >3.3用户知悉并确认，</span
              ><span style="font-family:微软雅黑; font-size:12pt">M Art</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >将运用各种安全技术和程序建立完善的管理制度来保护用户的个人信息，以免遭受未经授权的访问、使用或披露。
              </span>
            </p>
            <p
              style="line-height:25pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0"
            >
              <span style="font-family:微软雅黑; font-size:12pt">3.4</span
              ><span
                style="font-family:微软雅黑; font-size:12pt; font-weight:bold; text-decoration:underline"
              >若用户是18周岁以下的未成年人，在使用</span
              ><span
                style="font-family:微软雅黑; font-size:12pt; font-weight:bold; text-decoration:underline"
              >M Art</span
              ><span
                style="font-family:微软雅黑; font-size:12pt; font-weight:bold; text-decoration:underline"
              >的服务前，应事先取得用户家长或法定监护人（以下简称"监护人"）的书面同意。</span
              ><span style="font-family:微软雅黑; font-size:12pt"> </span>
            </p>
            <p
              style="line-height:25pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0"
            >
              <span
                style="font-family:微软雅黑; font-size:12pt"
              >3.5用户在使用本服务时须遵守国家法律法规及政策规定，不得利用本服务从事任何违法违规行为，包括但不限于：
              </span>
            </p>
            <p
              style="line-height:25pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0"
            >
              <span style="font-family:微软雅黑; font-size:12pt">（</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >1）发布、传送、传播、储存危害国家安全统一、破坏社会稳定、违反公序良俗、侮辱、诽谤、淫秽、暴力以及任何违反国家法律法规的内容；
              </span>
            </p>
            <p
              style="line-height:25pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0"
            >
              <span style="font-family:微软雅黑; font-size:12pt">（</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >2）发布、传送、传播、储存侵害他人知识产权、商业秘密等合法权利的内容；
              </span>
            </p>
            <p
              style="line-height:25pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0"
            >
              <span style="font-family:微软雅黑; font-size:12pt">（</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >3）恶意虚构事实、隐瞒真相以误导、欺骗他人
              </span>
            </p>
            <p
              style="line-height:25pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0"
            >
              <span style="font-family:微软雅黑; font-size:12pt">（</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >4）发布、传送、传播广告信息及垃圾信息；
              </span>
            </p>
            <p
              style="line-height:25pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0"
            >
              <span style="font-family:微软雅黑; font-size:12pt">（</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >5）其他法律法规禁止的行为。
              </span>
            </p>
            <p
              style="line-height:25pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0"
            >
              <span
                style="font-family:微软雅黑; font-size:12pt"
              >3.6如果用户违反了本条约定，相关国家机关或机构可能会对您提起诉讼、罚款或采取其他制裁措施，并要求</span
              ><span style="font-family:微软雅黑; font-size:12pt">M Art</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >给予协助。造成损害的，用户应依法予以赔偿，</span
              ><span style="font-family:微软雅黑; font-size:12pt">M Art</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >不承担任何责任。
              </span>
            </p>
            <p
              style="line-height:25pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0"
            >
              <span style="font-family:微软雅黑; font-size:12pt">3.7如果</span
              ><span style="font-family:微软雅黑; font-size:12pt">M Art</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >发现或收到他人举报用户发布的信息违反本条约定，</span
              ><span style="font-family:微软雅黑; font-size:12pt">M Art</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >有权进行独立判断并采取技术手段予以删除、屏蔽或断开链接。同时，</span
              ><span style="font-family:微软雅黑; font-size:12pt">M Art</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >有权视用户的行为性质，采取包括但不限于暂停或终止服务，限制、冻结或终止</span
              ><span style="font-family:微软雅黑; font-size:12pt">账号</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >使用，追究法律责任等措施。
              </span>
            </p>
            <p
              style="line-height:25pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0"
            >
              <span
                style="font-family:微软雅黑; font-size:12pt"
              >3.8用户违反本条约定，导致任何第三方损害的，用户应当独立承担责任并自行解决；</span
              ><span style="font-family:微软雅黑; font-size:12pt">M Art</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >因此遭受损失的，您也应当一并赔偿。
              </span>
            </p>
            <p
              style="line-height:25pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0"
            >
              <span style="font-family:微软雅黑; font-size:12pt">4.</span
              ><span style="font-family:微软雅黑; font-size:12pt">M Art</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >的权利义务</span
              >
            </p>
            <p
              style="line-height:25pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0"
            >
              <span
                style="font-family:微软雅黑; font-size:12pt"
              >4.1保护您及用户的信息的安全是</span
              ><span style="font-family:微软雅黑; font-size:12pt">M Art</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >的一项基本原则，未经您及用户的同意，</span
              ><span style="font-family:微软雅黑; font-size:12pt">M Art</span
              ><span style="font-family:微软雅黑; font-size:12pt">不会向</span
              ><span style="font-family:微软雅黑; font-size:12pt">M Art</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >以外的任何公司、组织和个人披露、提供您的信息，但下列情形除外：</span
              >
            </p>
            <p
              style="line-height:25pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0"
            >
              <span style="font-family:微软雅黑; font-size:12pt">（</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >1）据本协议或其他相关协议、规则等约定可以提供的；
              </span>
            </p>
            <p
              style="line-height:25pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0"
            >
              <span style="font-family:微软雅黑; font-size:12pt">（</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >2）依据法律法规的规定可以提供的；
              </span>
            </p>
            <p
              style="line-height:25pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0"
            >
              <span style="font-family:微软雅黑; font-size:12pt">（</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >3）行政、司法等政府部门要求提供的；
              </span>
            </p>
            <p
              style="line-height:25pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0"
            >
              <span style="font-family:微软雅黑; font-size:12pt">（</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >4）您同意</span
              ><span style="font-family:微软雅黑; font-size:12pt">M Art</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >向第三方提供；
              </span>
            </p>
            <p
              style="line-height:25pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0"
            >
              <span style="font-family:微软雅黑; font-size:12pt">（</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >5）为解决举报事件、提起诉讼而需要提供的；
              </span>
            </p>
            <p
              style="line-height:25pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0"
            >
              <span style="font-family:微软雅黑; font-size:12pt">（</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >6）为防止严重违法行为或涉嫌犯罪行为发生而采取必要合理行动所必须提供的。
              </span>
            </p>
            <p
              style="line-height:25pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0"
            >
              <span style="font-family:微软雅黑; font-size:12pt">4.2尽管</span
              ><span style="font-family:微软雅黑; font-size:12pt">M Art</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >对您及用户的信息保护做了极大的努力，但是仍然不能保证在现有的安全技术措施下，您及用户的信息可能会因为不可抗力或非</span
              ><span style="font-family:微软雅黑; font-size:12pt">M Art</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >因素造成泄漏、窃取等，由此给您及用户造成损失的，您及用户同意</span
              ><span style="font-family:微软雅黑; font-size:12pt">M Art</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >可以免责。</span
              >
            </p>
            <p
              style="line-height:25pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0"
            >
              <span style="font-family:微软雅黑; font-size:12pt">4.3</span
              ><span style="font-family:微软雅黑; font-size:12pt">M Art</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >有权开发、运营与您作品相似或相竞争的作品，同时</span
              ><span style="font-family:微软雅黑; font-size:12pt">M Art</span
              ><span style="font-family:微软雅黑; font-size:12pt">也不保证</span
              ><span style="font-family:微软雅黑; font-size:12pt">M Art</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >平台上不会出现其他投稿人提供的与您的作品相竞争的作品。
              </span>
            </p>
            <p
              style="line-height:25pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0"
            >
              <span style="font-family:微软雅黑; font-size:12pt">4.4</span
              ><span style="font-family:微软雅黑; font-size:12pt">M Art</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >有权在包括但不限于作品介绍、下载页面等，向用户阐述该作品为您上传以及由您向用户提供客户服务等。
              </span>
            </p>
            <p
              style="line-height:25pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0"
            >
              <span style="font-family:微软雅黑; font-size:12pt">4.5</span
              ><span style="font-family:微软雅黑; font-size:12pt">M Art</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >可将本协议下的权利和义务的部分或全部转让给他人，您如果不同意</span
              ><span style="font-family:微软雅黑; font-size:12pt">M Art</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >的该转让，则有权停止使用本协议下的服务。否则，视为您对此予以接受。
              </span>
            </p>
            <p
              style="line-height:25pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0"
            >
              <span
                style="font-family:微软雅黑; font-size:12pt"
              >4.6除了另行有约定外，</span
              ><span style="font-family:微软雅黑; font-size:12pt">M Art</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >无需为按照本协议享有的权益而向您及用户支付任何费用。
              </span>
            </p>
            <p
              style="line-height:25pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0"
            >
              <span
                style="font-family:微软雅黑; font-size:12pt; font-weight:normal"
              >4.7</span
              ><span
                style="font-family:微软雅黑; font-size:12pt; font-weight:bold; text-decoration:underline"
              >您理解并同意：为向更多互联网使用者推广您的作品，</span
              ><span
                style="font-family:微软雅黑; font-size:12pt; font-weight:bold; text-decoration:underline"
              >M Art</span
              ><span
                style="font-family:微软雅黑; font-size:12pt; font-weight:bold; text-decoration:underline"
              >有权采取以下行为，而无须再取得您的同意：</span
              >
            </p>
            <p
              style="line-height:25pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0"
            >
              <span
                style="font-family:微软雅黑; font-size:12pt; font-weight:bold; text-decoration:underline"
              >（</span
              ><span
                style="font-family:微软雅黑; font-size:12pt; font-weight:bold; text-decoration:underline"
              >1）在</span
              ><span
                style="font-family:微软雅黑; font-size:12pt; font-weight:bold; text-decoration:underline"
              >M Art</span
              ><span
                style="font-family:微软雅黑; font-size:12pt; font-weight:bold; text-decoration:underline"
              >平台以外的平台、网站等采取各种形式对作品进行宣传、推广；
              </span>
            </p>
            <p
              style="line-height:25pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0"
            >
              <span
                style="font-family:微软雅黑; font-size:12pt; font-weight:bold; text-decoration:underline"
              >（</span
              ><span
                style="font-family:微软雅黑; font-size:12pt; font-weight:bold; text-decoration:underline"
              >2）</span
              ><span
                style="font-family:微软雅黑; font-size:12pt; font-weight:bold; text-decoration:underline"
              >M Art</span
              ><span
                style="font-family:微软雅黑; font-size:12pt; font-weight:bold; text-decoration:underline"
              >可根据整体运营安排，自主选择向整个或部分全球范围内的互联网用户提供您的作品服务，但您与</span
              ><span
                style="font-family:微软雅黑; font-size:12pt; font-weight:bold; text-decoration:underline"
              >M Art</span
              ><span
                style="font-family:微软雅黑; font-size:12pt; font-weight:bold; text-decoration:underline"
              >签署的其他书面协议另有约定的除外；
              </span>
            </p>
            <p
              style="line-height:25pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0"
            >
              <span
                style="font-family:微软雅黑; font-size:12pt; font-weight:bold; text-decoration:underline"
              >（</span
              ><span
                style="font-family:微软雅黑; font-size:12pt; font-weight:bold; text-decoration:underline"
              >3）为宣传、推广作品，</span
              ><span
                style="font-family:微软雅黑; font-size:12pt; font-weight:bold; text-decoration:underline"
              >M Art</span
              ><span
                style="font-family:微软雅黑; font-size:12pt; font-weight:bold; text-decoration:underline"
              >可根据</span
              ><span
                style="font-family:微软雅黑; font-size:12pt; font-weight:bold; text-decoration:underline"
              >M Art</span
              ><span
                style="font-family:微软雅黑; font-size:12pt; font-weight:bold; text-decoration:underline"
              >平台的功能设计使用您作品的标题、名称、人物形象、构想、图片等相关素材，或为用户提供不限于聊天场景内的、更丰富的作品使用场景。
              </span>
            </p>
            <p
              style="line-height:25pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0"
            >
              <span
                style="font-family:微软雅黑; font-size:12pt"
              >5.用户信息收集、使用及保护</span
              >
            </p>
            <p
              style="line-height:25pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0"
            >
              <span
                style="font-family:微软雅黑; font-size:12pt"
              >5.1您同意并授权</span
              ><span style="font-family:微软雅黑; font-size:12pt">M Art</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >为履行本协议之目的收集您及用户的信息，这些信息包括您及用户在注册系统中注册的信息、您及用户账号下的数据以及其他您及用户在使用本服务的过程中向</span
              ><span style="font-family:微软雅黑; font-size:12pt">M Art</span
              ><span style="font-family:微软雅黑; font-size:12pt">提供或</span
              ><span style="font-family:微软雅黑; font-size:12pt">M Art</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >基于安全、用户体验优化等考虑而需收集的信息，</span
              ><span style="font-family:微软雅黑; font-size:12pt">M Art</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >对您及用户的信息的收集将遵循相关法律规定。
              </span>
            </p>
            <p
              style="line-height:25pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0"
            >
              <span
                style="font-family:微软雅黑; font-size:12pt"
              >5.2您及用户充分理解并同意：</span
              ><span style="font-family:微软雅黑; font-size:12pt">M Art</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >或其合作的第三方可以根据您及用户的信息，通过短信、电话、邮件等各种方式向您及用户提供关于</span
              ><span style="font-family:微软雅黑; font-size:12pt">M Art</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >的活动信息、推广信息等各类信息。
              </span>
            </p>
            <p
              style="line-height:25pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0"
            >
              <span
                style="font-family:微软雅黑; font-size:12pt"
              >5.3保护用户信息及隐私是</span
              ><span style="font-family:微软雅黑; font-size:12pt">M Art</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >的一项基本原则。除本协议另有规定外，本服务对用户信息收集、使用及保护等将遵循</span
              ><span style="font-family:微软雅黑; font-size:12pt">M Art</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >统一公布的相关隐私政策。
              </span>
            </p>
            <p
              style="line-height:25pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0"
            >
              <span
                style="font-family:微软雅黑; font-size:12pt"
              >6.收费服务</span
              >
            </p>
            <p
              style="line-height:25pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0"
            >
              <span style="font-family:微软雅黑; font-size:12pt">6.1</span
              ><span style="font-family:微软雅黑; font-size:12pt">M Art</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >的部分服务是以收费方式提供的，如您及用户使用收费服务，请遵守相关的协议、
              </span>
            </p>
            <p
              style="line-height:25pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0"
            >
              <span style="font-family:微软雅黑; font-size:12pt">6.2</span
              ><span style="font-family:微软雅黑; font-size:12pt">M Art</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >可能根据实际需要对收费服务的收费标准、方式进行修改和变更，</span
              ><span style="font-family:微软雅黑; font-size:12pt">M Art</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >也可能会对部分免费服务开始收费。前述修改、变更或开始收费前，</span
              ><span style="font-family:微软雅黑; font-size:12pt">M Art</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >将在相应服务页面进行通知或公告。如果您及用户不同意上述修改、变更或付费内容，请及时停止使用该服务。
              </span>
            </p>
            <p
              style="line-height:25pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0"
            >
              <span
                style="font-family:微软雅黑; font-size:12pt"
              >7.关于免责</span
              >
            </p>
            <p
              style="line-height:25pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0"
            >
              <span
                style="font-family:微软雅黑; font-size:12pt"
              >7.1您及用户理解并同意：鉴于网络服务的特殊性，</span
              ><span style="font-family:微软雅黑; font-size:12pt">M Art</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >有权在无需通知您及用户的情况下根据</span
              ><span style="font-family:微软雅黑; font-size:12pt">M Art</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >平台的整体运营情况或相关运营规范、规则等，可以随时变更、中止或终止部分或全部的服务，若由此给您及用户造成损失的，您及用户同意放弃追究</span
              ><span style="font-family:微软雅黑; font-size:12pt">M Art</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >的责任。
              </span>
            </p>
            <p
              style="line-height:25pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0"
            >
              <span
                style="font-family:微软雅黑; font-size:12pt"
              >7.2您及用户理解并同意：为了向您及用户提供更完善的服务，</span
              ><span style="font-family:微软雅黑; font-size:12pt">M Art</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >有权定期或不定期地对提供本服务的平台或相关设备进行检修、维护、升级等，此类情况可能会造成相关服务在合理时间内中断或暂停的，若由此给您及用户造成损失的，您及用户同意放弃追究</span
              ><span style="font-family:微软雅黑; font-size:12pt">M Art</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >的责任。
              </span>
            </p>
            <p
              style="line-height:25pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0"
            >
              <span
                style="font-family:微软雅黑; font-size:12pt"
              >7.3您及用户理解并同意：</span
              ><span style="font-family:微软雅黑; font-size:12pt">M Art</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >的服务是按照现有技术和条件所能达到的现状提供的。</span
              ><span style="font-family:微软雅黑; font-size:12pt">M Art</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >会尽最大努力向您及用户提供服务，确保服务的连贯性和安全性；但</span
              ><span style="font-family:微软雅黑; font-size:12pt">M Art</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >不能保证其所提供的服务毫无瑕疵，也无法随时预见和防范法律、技术以及其他风险，包括但不限于不可抗力、病毒、木马、黑客攻击、系统不稳定、第三方服务瑕疵、政府行为等原因可能导致的服务中断、数据丢失以及其他的损失和风险。所以您及用户也同意：即使</span
              ><span style="font-family:微软雅黑; font-size:12pt">M Art</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >提供的服务存在瑕疵，但上述瑕疵是当时行业技术水平所无法避免的，其将不被视为</span
              ><span style="font-family:微软雅黑; font-size:12pt">M Art</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >违约，同时，由此给您及用户造成的数据或信息丢失等</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >损失的，您及用户同意放弃追究</span
              ><span style="font-family:微软雅黑; font-size:12pt">M Art</span
              ><span style="font-family:微软雅黑; font-size:12pt">的责任。</span
              ><span style="font-family:微软雅黑; font-size:12pt"> </span>
            </p>
            <p
              style="line-height:25pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0"
            >
              <span
                style="font-family:微软雅黑; font-size:12pt"
              >7.4您及用户理解并同意：在使用本服务的过程中，可能会遇到不可抗力等风险因素，使本服务发生中断。不可抗力是指不能预见、不能克服并不能避免且对一方或双方造成重大影响的客观事件，包括但不限于自然灾害如洪水、地震、瘟疫流行和风暴等以及社会事件如战争、动乱、政府行为等。出现上述情况时，</span
              ><span style="font-family:微软雅黑; font-size:12pt">M Art</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >将努力在第一时间与相关单位配合，及时进行修复，若由此给您及用户造成损失的，您及用户同意放弃追究</span
              ><span style="font-family:微软雅黑; font-size:12pt">M Art</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >的责任。
              </span>
            </p>
            <p
              style="line-height:25pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0"
            >
              <span
                style="font-family:微软雅黑; font-size:12pt"
              >7.5您及用户理解并同意：第三方在</span
              ><span style="font-family:微软雅黑; font-size:12pt">M Art</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >平台中投放的广告、链接或者其它形式的宣传推广内容，均是由其自行提供的，您及用户应当自行判断其真实性，</span
              ><span style="font-family:微软雅黑; font-size:12pt">M Art</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >对其推广内容不作任何明示或者默示的担保。
              </span>
            </p>
            <p
              style="line-height:25pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0"
            >
              <span
                style="font-family:微软雅黑; font-size:12pt"
              >7.6您及用户理解并同意：若由于对以下情形导致的服务中断或受阻，给您及用户造成损失的，您及用户同意放弃追究</span
              ><span style="font-family:微软雅黑; font-size:12pt">M Art</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >的责任：
              </span>
            </p>
            <p
              style="line-height:25pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0"
            >
              <span style="font-family:微软雅黑; font-size:12pt">（</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >1）受到计算机病毒、木马或其他恶意程序、黑客攻击的破坏；
              </span>
            </p>
            <p
              style="line-height:25pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0"
            >
              <span style="font-family:微软雅黑; font-size:12pt">（</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >2）您及用户或</span
              ><span style="font-family:微软雅黑; font-size:12pt">M Art</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >的电脑软件、系统、硬件和通信线路出现故障；
              </span>
            </p>
            <p
              style="line-height:25pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0"
            >
              <span style="font-family:微软雅黑; font-size:12pt">（</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >3）您及用户操作不当；
              </span>
            </p>
            <p
              style="line-height:25pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0"
            >
              <span style="font-family:微软雅黑; font-size:12pt">（</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >4）您及用户通过非</span
              ><span style="font-family:微软雅黑; font-size:12pt">M Art</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >授权的方式使用本服务；
              </span>
            </p>
            <p
              style="line-height:25pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0"
            >
              <span style="font-family:微软雅黑; font-size:12pt">（</span
              ><span style="font-family:微软雅黑; font-size:12pt">5）其他</span
              ><span style="font-family:微软雅黑; font-size:12pt">M Art</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >无法控制或合理预见的情形。
              </span>
            </p>
            <p
              style="line-height:25pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0"
            >
              <span
                style="font-family:微软雅黑; font-size:12pt"
              >8.服务的中止或终止</span
              >
            </p>
            <p
              style="line-height:25pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0"
            >
              <span
                style="font-family:微软雅黑; font-size:12pt"
              >8.1如您及用户书面通知</span
              ><span style="font-family:微软雅黑; font-size:12pt">M Art</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >不接受本协议或对其的修改，</span
              ><span style="font-family:微软雅黑; font-size:12pt">M Art</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >有权随时中止或终止向您及用户提供本服务。
              </span>
            </p>
            <p
              style="line-height:25pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0"
            >
              <span
                style="font-family:微软雅黑; font-size:12pt"
              >8.2因不可抗力因素导致您及用户无法继续使用本服务或</span
              ><span style="font-family:微软雅黑; font-size:12pt">M Art</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >无法提供本服务的，</span
              ><span style="font-family:微软雅黑; font-size:12pt">M Art</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >有权随时终止协议。
              </span>
            </p>
            <p
              style="line-height:25pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0"
            >
              <span
                style="font-family:微软雅黑; font-size:12pt"
              >8.3本协议约定的其他中止或终止条件发生或实现的，</span
              ><span style="font-family:微软雅黑; font-size:12pt">M Art</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >有权随时中止或终止向您及用户提供本服务。
              </span>
            </p>
            <p
              style="line-height:25pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0"
            >
              <span
                style="font-family:微软雅黑; font-size:12pt"
              >8.4由于您及用户违反本协议约定，</span
              ><span style="font-family:微软雅黑; font-size:12pt">M Art</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >依约终止向您及用户提供本服务后，如您及用户后续再直接或间接或以他人名义注册使用本服务的，</span
              ><span style="font-family:微软雅黑; font-size:12pt">M Art</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >有权单方面暂停或终止提供本服务。
              </span>
            </p>
            <p
              style="line-height:25pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0"
            >
              <span
                style="font-family:微软雅黑; font-size:12pt"
              >8.5如本协议或本服务因为任何原因终止的，对于您及用户的帐号中的全部数据或您及用户因使用本服务而存储在</span
              ><span style="font-family:微软雅黑; font-size:12pt">M Art</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >服务器中的数据等任何信息，</span
              ><span style="font-family:微软雅黑; font-size:12pt">M Art</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >可将该等信息保留或删除，包括服务终止前您及用户尚未完成的任何数据。
              </span>
            </p>
            <p
              style="line-height:25pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0"
            >
              <span
                style="font-family:微软雅黑; font-size:12pt"
              >8.6如本协议或本服务因为任何原因终止的，您及用户应自行处理好关于数据等信息的备份以及与您的用户之间的相关事项的处理等，由此造成</span
              ><span style="font-family:微软雅黑; font-size:12pt">M Art</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >损失的，您及用户应负责赔偿。
              </span>
            </p>
            <p
              style="line-height:25pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0"
            >
              <span
                style="font-family:微软雅黑; font-size:12pt"
              >8.7用户在本协议或本服务有效期内下载的作品，用户可永久使用。本协议或本服务的终止不影响用户对已下载作品的使用。
              </span>
            </p>
            <p
              style="line-height:25pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0"
            >
              <span
                style="font-family:微软雅黑; font-size:12pt"
              >9.关于通知</span
              >
            </p>
            <p
              style="line-height:25pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0"
            >
              <span style="font-family:微软雅黑; font-size:12pt">9.1</span
              ><span style="font-family:微软雅黑; font-size:12pt">M Art</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >可能会以一种或多种不同的方式（包括但不限于网页公告、网页提示、电子邮箱、手机短信、常规的信件传送、您及用户注册的本服务帐号的管理系统内发送站内信等）向您及用户送达关于本服务的各种规则、通知、提示等信息，该等信息一经</span
              ><span style="font-family:微软雅黑; font-size:12pt">M Art</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >采取前述任何一种方式公布或发送，即视为您及用户已经接受并同意，对您及用户产生约束力。若您及用户不接受的，请您及用户书面通知</span
              ><span style="font-family:微软雅黑; font-size:12pt">M Art</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >，否则视为您及用户已经接受、同意。
              </span>
            </p>
            <p
              style="line-height:25pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0"
            >
              <span
                style="font-family:微软雅黑; font-size:12pt"
              >9.2若由于您及用户提供的电子邮箱、手机号码、通讯地址等信息错误，导致您及用户未收到相关规则、通知、提示等信息的，您及用户同意仍然视为您及用户已经收到相关信息并受其约束，一切后果及责任由您及用户自行承担。
              </span>
            </p>
            <p
              style="line-height:25pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0"
            >
              <span
                style="font-family:微软雅黑; font-size:12pt"
              >9.3您及用户也同意</span
              ><span style="font-family:微软雅黑; font-size:12pt">M Art</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >或合作伙伴可以向您及用户的电子邮件、手机号码等发送可能与本服务不相关的其他各类信息包括但不限于商业广告等。
              </span>
            </p>
            <p
              style="line-height:25pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0"
            >
              <span
                style="font-family:微软雅黑; font-size:12pt"
              >9.4若您及用户有事项需要通知</span
              ><span style="font-family:微软雅黑; font-size:12pt">M Art</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >的，应当按照本服务对外正式公布的联系方式书面通知</span
              ><span style="font-family:微软雅黑; font-size:12pt">M Art</span
              ><span style="font-family:微软雅黑; font-size:12pt">。 </span>
            </p>
            <p
              style="line-height:25pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0"
            >
              <span
                style="font-family:微软雅黑; font-size:12pt"
              >10.知识产权</span
              >
            </p>
            <p
              style="line-height:25pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0"
            >
              <span style="font-family:微软雅黑; font-size:12pt">10.1</span
              ><span style="font-family:微软雅黑; font-size:12pt">M Art</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >在本服务中提供的信息内容（包括但不限于网页、文字、图片、音频、视频、图表</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >、制图素材</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >等）的知识产权均归</span
              ><span style="font-family:微软雅黑; font-size:12pt">M Art</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >所有，依法属于他人所有的除外。除另有特别声明外，</span
              ><span style="font-family:微软雅黑; font-size:12pt">M Art</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >提供本服务时所依托软件的著作权、专利权及其他知识产权均归</span
              ><span style="font-family:微软雅黑; font-size:12pt">M Art</span
              ><span style="font-family:微软雅黑; font-size:12pt">所有。</span>
            </p>
            <p
              style="line-height:25pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0"
            >
              <span
                style="font-family:微软雅黑; font-size:12pt"
              >10.2您及用户仅拥有依照本协议约定合法使用本服务的权利，与本服务相关的著作权、专利权等相关全部权利归</span
              ><span style="font-family:微软雅黑; font-size:12pt">M Art</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >所有。未经</span
              ><span style="font-family:微软雅黑; font-size:12pt">M Art</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >书面许可，您及用户不得违约或违法使用。</span
              >
            </p>
            <p
              style="line-height:25pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0"
            >
              <span style="font-family:微软雅黑; font-size:12pt">1</span
              ><span style="font-family:微软雅黑; font-size:12pt">0.3</span
              ><span
                style="font-family:微软雅黑; font-size:12pt; font-weight:bold"
              >您自行创作并上传</span
              ><span
                style="font-family:微软雅黑; font-size:12pt; font-weight:bold"
              >M Art</span
              ><span
                style="font-family:微软雅黑; font-size:12pt; font-weight:bold"
              >，或您利用</span
              ><span
                style="font-family:微软雅黑; font-size:12pt; font-weight:bold"
              >M Art</span
              ><span
                style="font-family:微软雅黑; font-size:12pt; font-weight:bold"
              >提供的技术支持创作的作品及素材的知识产权归您所有。但</span
              ><span
                style="font-family:微软雅黑; font-size:12pt; font-weight:bold"
              >M Art</span
              ><span
                style="font-family:微软雅黑; font-size:12pt; font-weight:bold"
              >有权依据本协议的约定在网站上进行展示、推广、文化经营等工作。</span
              >
            </p>
            <p
              style="line-height:25pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0"
            >
              <span style="font-family:微软雅黑; font-size:12pt">11.其他</span>
            </p>
            <p
              style="line-height:25pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0"
            >
              <span
                style="font-family:微软雅黑; font-size:12pt"
              >11.1本协议内容同时包括《</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              ><a style="color:blue" @click="active = '4'">创作规范</a></span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >》、本协议附件中的协议或规则、</span
              ><span style="font-family:微软雅黑; font-size:12pt">M Art</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >可能不断发布的关于本服务的其他相关协议、规则等内容。上述内容一经正式发布，即为本协议不可分割的组成部分，您及用户同样应当遵守。上述内容与本协议存在冲突的，以本协议为准。一经注册或使用本协议下任何服务，即视为您及用户已阅读并同意接受本协议及上述内容的约束。</span
              ><span style="font-family:微软雅黑; font-size:12pt">M Art</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >有权在必要时单方修改本协议或上述内容，相关内容变更后，如果您及用户继续使用本服务，即视为您及用户已接受修改后的相关内容。如果您及用户不接受修改后的相关内容，应当停</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >止使用相关服务。</span
              ><span style="font-family:微软雅黑; font-size:12pt"> </span>
            </p>
            <p
              style="line-height:25pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0"
            >
              <span
                style="font-family:微软雅黑; font-size:12pt"
              >11.2本协议签订地为中华人民共和国</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >广州市海珠区</span
              ><span style="font-family:微软雅黑; font-size:12pt">。 </span>
            </p>
            <p
              style="line-height:25pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0"
            >
              <span
                style="font-family:微软雅黑; font-size:12pt"
              >11.3本协议的成立、生效、履行、解释及纠纷解决，适用中华人民共和国大陆地区法律（不包括冲突法）。
              </span>
            </p>
            <p
              style="line-height:25pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0"
            >
              <span
                style="font-family:微软雅黑; font-size:12pt"
              >11.4若您及用户和</span
              ><span style="font-family:微软雅黑; font-size:12pt">M Art</span
              ><span
                style="font-family:微软雅黑; font-size:12pt"
              >之间发生任何纠纷或争议，首先应友好协商解决；协商不成功的，各方均同意将纠纷或争议提交本协议签订地有管辖权的人民法院解决
              </span>
            </p>
            <p
              style="line-height:25pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0"
            >
              <span
                style="font-family:微软雅黑; font-size:12pt"
              >11.5本协议所有条款的标题仅为阅读方便，本身并无实际涵义，不能作为本协议涵义解释的依据。（正文完）</span
              >
            </p>
          </div>
        </div>
        <div v-if="activeAgree === 2">
          <div>
            <h3
              style="background-color:#ffffff; line-height:12pt; margin:5pt 0pt; text-align:center"
            >
              <span
                style="background-color:#ffffff; font-family:微软雅黑; font-size:12pt; font-weight:bold"
              >M Art隐私政策</span
              >
            </h3>
            <p
              style="background-color:#ffffff; line-height:25pt; margin:5pt 0pt; text-indent:21pt"
            >
              <span
                style="background-color:#ffffff; font-family:微软雅黑; font-size:12pt"
              >感谢您选择使用M Art平台，您可以通过多种不同的方式使用我们的服务。我们希望通过本隐私政策让您清楚的了解我们对信息的收集、使用方式，以及您可采用什么方式来保护自己的隐私权。当您注册M Art平台时，视为同意本政策。</span
              >
            </p>
            <p
              style="background-color:#ffffff; line-height:25pt; margin:5pt 0pt"
            >
              <span
                style="background-color:#ffffff; font-family:微软雅黑; font-size:12pt"
              >我们的隐私权政策解释了以下几个方面的问题：</span
              >
            </p>
            <p
              style="background-color:#ffffff; line-height:25pt; margin:5pt 0pt"
            >
              <span
                style="background-color:#ffffff; font-family:微软雅黑; font-size:12pt"
              >（1）我们收集这些信息的目的、范围以及如何收集；</span
              ><br /><span
                style="background-color:#ffffff; font-family:微软雅黑; font-size:12pt"
              >（2）我们对这些信息的使用方式、范围；</span
              ><br /><span
                style="background-color:#ffffff; font-family:微软雅黑; font-size:12pt"
              >（3）信息的安全性；</span
              ><br /><span
                style="background-color:#ffffff; font-family:微软雅黑; font-size:12pt"
              >（4）未成年人信息保护等。</span
              >
            </p>
            <h4
              style="background-color:#ffffff; line-height:25pt; margin:5pt 0pt"
            >
              <span
                style="background-color:#ffffff; font-family:微软雅黑; font-size:12pt; font-weight:bold"
              >一、 收集信息的目的</span
              >
            </h4>
            <p
              style="background-color:#ffffff; line-height:25pt; margin:5pt 0pt"
            >
              <span
                style="background-color:#ffffff; font-family:微软雅黑; font-size:12pt"
              >我们通过网站、软件和其他应用程序向您提供更为优质的作品分享、拍照、上传图片、形象贴图等服务。</span
              ><br /><span
                style="background-color:#ffffff; font-family:微软雅黑; font-size:12pt"
              >如果您不同意M Art平台的用户协议和本隐私权政策，请您不要使用M Art平台（如果您已经开始使用M Art平台，请您立即终止使用，您的使用行为即视为您同意。）</span
              ><br /><span
                style="background-color:#ffffff; font-family:微软雅黑; font-size:12pt"
              >如在使用部分功能过程中不同意M Art平台收集、显示和使用您的信息的，将可能会影响到您对此部分功能的使用和体验，您对此表示理解。</span
              >
            </p>
            <h4
              style="background-color:#ffffff; line-height:25pt; margin:5pt 0pt"
            >
              <span
                style="background-color:#ffffff; font-family:微软雅黑; font-size:12pt; font-weight:bold"
              >二、 收集信息的类型</span
              >
            </h4>
            <p
              style="background-color:#ffffff; line-height:25pt; margin:5pt 0pt"
            >
              <span
                style="background-color:#ffffff; font-family:微软雅黑; font-size:12pt"
              >按是否能辨识个人身份,本合同项下的信息可以分为以下两类：</span
              ><br /><span
                style="background-color:#ffffff; font-family:微软雅黑; font-size:12pt"
              >（1）可辨识个人身份的信息：包括用户真实姓名、出生日期、身份证件号码、职业、住址、电话号码、账号和密码以及用户使用服务的时间、地点、发布内容能够单独或者与其他信息结合识别用户的信息。</span
              ><br /><span
                style="background-color:#ffffff; font-family:微软雅黑; font-size:12pt"
              >（2）不可辨识个人身份的信息：可以是您使用M Art平台的使用记录、个人喜好这些与您有关但无法直接辨认、追查、鉴别、确认个人真实身份的信息。我们例行收集此类信息并用于改善您的体验。</span
              >
            </p>
            <h4
              style="background-color:#ffffff; line-height:25pt; margin:5pt 0pt"
            >
              <span
                style="background-color:#ffffff; font-family:微软雅黑; font-size:12pt; font-weight:bold"
              >三、 我们收集哪些信息/如何收集信息</span
              >
            </h4>
            <p
              style="background-color:#ffffff; line-height:25pt; margin:5pt 0pt"
            >
              <span
                style="background-color:#ffffff; font-family:微软雅黑; font-size:12pt"
              >您在使用M Art平台的同时，不可撤销地同意并授权我们获取您的如下信息：</span
              >
            </p>
            <p
              style="background-color:#ffffff; line-height:25pt; margin:5pt 0pt"
            >
              <span
                style="background-color:#ffffff; font-family:微软雅黑; font-size:12pt; font-weight:bold"
              >1. 您提交的信息</span
              ><br /><span
                style="background-color:#ffffff; font-family:微软雅黑; font-size:12pt"
              >1)
                为向您提供帐号注册服务时进行的用户身份识别，需要您填写手机号码以验证真实性。</span
              ><br /><span
                style="background-color:#ffffff; font-family:微软雅黑; font-size:12pt"
              >2)
                在您需要注销账号时，为验证为本人操作而要求您提供身份证、手机号码、账号持有证明的相关信息、电子邮箱、联系地址，若您是未成年人的，还需提供监护人身份证明及监护人同意提供上述信息的证明材料。</span
              ><br /><span
                style="background-color:#ffffff; font-family:微软雅黑; font-size:12pt"
              >3)
                若您提供的信息不完整，则无法使用本服务或在使用过程中受到限制。如信息变更，您应及时更新。</span
              ><br /><span
                style="background-color:#ffffff; font-family:微软雅黑; font-size:12pt; font-weight:bold"
              >2.您使用M Art平台服务过程中产生的信息</span
              ><br /><span
                style="background-color:#ffffff; font-family:微软雅黑; font-size:12pt"
              >除上述可能会采集的信息外，还可能采集您在使用本服务的过程中所产生的日志信息、IP地址和移动设备所用的版本和设备识别码、相关通讯信息、地理位置信息、Web
                Beacon或Cookie信息及其他使用本服务过程中产生的信息。您可通过终端设备的权限设置关闭相关授权以阻止本软件获取您的相关信息。</span
              ><br /><span
                style="background-color:#ffffff; font-family:微软雅黑; font-size:12pt; font-weight:bold"
              >3. 我们从第三方获得您个人信息的情形</span
              ><br /><span
                style="background-color:#ffffff; font-family:微软雅黑; font-size:12pt"
              >如您启用第三方应用的服务，我们可能从第三方获取您授权共享的账户信息（头像、昵称），并在您同意本隐私政策后将您的第三方账户与您的软件账户绑定，使您可以通过第三方账户直接登录并使用我们的产品与/或服务。在符合相关本隐私政策的前提下，使用您的这些个人信息。</span
              >
            </p>
            <h4
              style="background-color:#ffffff; line-height:25pt; margin:5pt 0pt"
            >
              <span
                style="background-color:#ffffff; font-family:微软雅黑; font-size:12pt; font-weight:bold"
              >四、 信息使用和存储规则</span
              >
            </h4>
            <p style="background-color:#ffffff; margin:0pt">
              <span
                style="background-color:#ffffff; font-family:微软雅黑; font-size:12pt"
              >1.
                我们会根据本隐私政策的约定并为实现我们的产品与/或服务功能对所收集的个人信息进行使用。</span
              ><br /><span
                style="background-color:#ffffff; font-family:微软雅黑; font-size:12pt"
              >2.</span
              ><span
                style="background-color:#ffffff; font-family:微软雅黑; font-size:12pt"
              >&nbsp;</span
              ><span
                style="background-color:#ffffff; font-family:微软雅黑; font-size:12pt"
              >您已明确授权</span
              ><span
                style="background-color:#ffffff; font-family:微软雅黑; font-size:12pt"
              >，为提供服务、履行协议、解决争议、保障交易安全等目的，M Art平台对您注册所提供的、M Art平台自行收集的及通过第三方收集的您的个人信息、您申请服务时的相关信息、您在使用服务时储存在M Art平台的个人信息享有留存、整理加工、使用和披露的权利，具体方式包括但不限于：</span
              ><br /><span
                style="background-color:#ffffff; font-family:微软雅黑; font-size:12pt"
              >1)
                出于为您帮助完成注册或提供服务的需要获取您的个人信息，对于虚拟账号名称、头像、性别、爱好、生日可在本网站公示。</span
              ><br /><span
                style="background-color:#ffffff; font-family:微软雅黑; font-size:12pt"
              >2)
                使用您的用户信息以改进本网站的设计和推广，对我们的产品与/或服务使用情况进行统计，并可能会与公众或第三方共享这些统计信息，以展示我们的产品与/或服务的整体使用趋势。但当我们展示您的个人信息时，我们会采用包括内容替换、匿名处理方式对您的信息进行脱敏，以保护您的信息安全。</span
              ><br /><span
                style="background-color:#ffffff; font-family:微软雅黑; font-size:12pt"
              >3)
                使用您提供的联系方式与您联络并向您传递有关服务和管理方面的信息，对您的个人信息进行分析整合。</span
              ><br /><span
                style="background-color:#ffffff; font-family:微软雅黑; font-size:12pt"
              >4)
                当您与我们联系时，我们可能会保存您的沟通记录和内容或您留下的联系方式等信息，以便与您联系或帮助您解决问题，并记录相关问题的处理方案及结果。</span
              ><br /><span
                style="background-color:#ffffff; font-family:微软雅黑; font-size:12pt"
              >5)
                为方便您在使用服务过程中能使用更换图像、上传或下载图片、实名认证的功能而使用您的相机、相册权限。</span
              ><br /><span
                style="background-color:#ffffff; font-family:微软雅黑; font-size:12pt"
              >6) 出于服务运行过程中的数据存储而使用您的存储权限。</span
              ><br /><span
                style="background-color:#ffffff; font-family:微软雅黑; font-size:12pt"
              >7)在您违反与M Art平台或M Art平台的其他用户签订的协议时，披露您的个人信息及违约事实，将您的违约信息写入黑名单并与必要的第三方共享数据，以供M Art平台及第三方审核、追索之用。</span
              ><br /><span
                style="background-color:#ffffff; font-family:微软雅黑; font-size:12pt"
              >8)
                其他基于特定目的收集而来的信息用于其他目的时，会通过您主动做出勾选或同意的形式事先征求您的同意。</span
              ><br /><span
                style="background-color:#ffffff; font-family:微软雅黑; font-size:12pt"
              >3.
                您同意并授权M Art平台或相关服务提供者向您推送电子广告，推送者会在推送中明示发送者的真实身份和联系方式，并向您提供拒绝继续接收的方式。</span
              ><br /><span
                style="background-color:#ffffff; font-family:微软雅黑; font-size:12pt"
              >4.
                请您注意，您在使用我们的产品与/或服务时所提供的所有个人信息，除非您删除或通过系统设置拒绝我们收集，否则将在您使用我们的产品与/或服务期间持续授权我们使用。在您注销账号时，我们将停止使用并收集您的个人信息。</span
              ><br /><span
                style="background-color:#ffffff; font-family:微软雅黑; font-size:12pt"
              >5
                若非系统崩溃、黑客入侵等意外情况，一般情况下，您的网络操作日志、产品使用记录信息将按照相关法律法规的要求保存至少6个月。账户及软件正常状态下，您可随时浏览、修改自己提交的信息，在访问、更新、更正和删除您的信息时，我们有权要求您进行身份验证，以保障账户安全。</span
              ><br /><span
                style="background-color:#ffffff; font-family:微软雅黑; font-size:12pt; text-decoration:underline"
              >6.
                您可通过邮箱M Art@mindcomic.com向我们发送注销账号申请，并按照既定流程提供相应信息以供验证。如您注销账户的，M Art平台有权不再保存您的信息，请您自行做好备份和记录</span
              ><span
                style="background-color:#ffffff; font-family:微软雅黑; font-size:12pt; font-weight:bold; text-decoration:underline"
              >。</span
              >
            </p>
            <h4
              style="background-color:#ffffff; line-height:25pt; margin:5pt 0pt"
            >
              <span
                style="background-color:#ffffff; font-family:微软雅黑; font-size:12pt; font-weight:bold"
              >五、 我们如何保护您的个人信息安全</span
              >
            </h4>
            <p
              style="background-color:#ffffff; line-height:25pt; margin:5pt 0pt"
            >
              <span
                style="background-color:#ffffff; font-family:微软雅黑; font-size:12pt"
              >我们非常重视个人信息安全，并采取一切合理可行的措施，保护您的个人信息。但是请您理解，由于技术的限制以及可能存在的各种恶意手段，即便竭尽所能加强安全措施，也不能完全避免与个人信息安全相关的风险（特别是由于我们可控范围外的因素而引发问题时，如不可抗力或第三方原因等），</span
              ><span
                style="background-color:#ffffff; font-family:微软雅黑; font-size:12pt; font-weight:bold"
              >因此，M Art平台无法确保用户的个人信息完全不被泄露，请您审慎提供个人信息，对于跳转第三方的界面谨慎点击。</span
              ><br /><span
                style="background-color:#ffffff; font-family:微软雅黑; font-size:12pt"
              >如果我们知悉其所获取并储存的数据安全受到危害或由于外部行为收到侵犯，我们仍将采取其认为适当的合理措施（包括但不限于内部调查、上报并通知执法机构以及配合执法机构工作等），我们同时也会在认为适当的情况下采取合法合理措施通知您。</span
              >
            </p>
            <h4
              style="background-color:#ffffff; line-height:25pt; margin:5pt 0pt"
            >
              <span
                style="background-color:#ffffff; font-family:微软雅黑; font-size:12pt; font-weight:bold"
              >六、 未成年人的个人信息保护</span
              >
            </h4>
            <p
              style="background-color:#ffffff; line-height:25pt; margin:5pt 0pt"
            >
              <span
                style="background-color:#ffffff; font-family:微软雅黑; font-size:12pt"
              >我们非常重视对未成年人个人信息的保护</span
              ><span
                style="background-color:#ffffff; font-family:微软雅黑; font-size:12pt; font-weight:bold; text-decoration:underline"
              >并建议未成年人在提交信息之前务必经过父母或监护人的同意和指导。</span
              ><br /><span
                style="background-color:#ffffff; font-family:微软雅黑; font-size:12pt"
              >若您是18周岁以下的未成年人，我们根据国家相关法律法规的规定保护未成年人的个人信息。对于经父母或法定监护人同意而收集未成年人个人信息的情况，我们只会在受到法律允许、父母或监护人明确同意或者保护未成年人所必要的情况下使用或公开披露此信息。</span
              >
            </p>
            <h4
              style="background-color:#ffffff; line-height:25pt; margin:5pt 0pt"
            >
              <span
                style="background-color:#ffffff; font-family:微软雅黑; font-size:12pt; font-weight:bold"
              >七、 其他</span
              >
            </h4>
            <p
              style="background-color:#ffffff; line-height:25pt; margin:5pt 0pt"
            >
              <span
                style="background-color:#ffffff; font-family:微软雅黑; font-size:12pt"
              >如您还有任何疑问或其他与隐私政策相关的问题、投诉，欢迎通过如下方式与我们取得联系：</span
              ><span
                style="background-color:#ffffff; font-family:微软雅黑; font-size:12pt; font-weight:bold; text-decoration:underline"
              ><span class="email-word" style="width: 182px; background-color: rgba(0, 0, 0, 0.65);">&nbsp;</span></span
              ><span
                style="background-color:#ffffff; font-family:微软雅黑; font-size:12pt; text-decoration:underline"
              >&nbsp;</span
              ><span
                style="background-color:#ffffff; font-family:微软雅黑; font-size:12pt; font-weight:bold; text-decoration:underline"
              ></span
              ><span
                style="background-color:#ffffff; font-family:微软雅黑; font-size:12pt; text-decoration:underline"
              >&nbsp;</span
              ><span
                style="background-color:#ffffff; font-family:微软雅黑; font-size:12pt"
              >并留下真实有效的联系方式，我们将在收到相关问题或投诉之日起15日内回复。</span
              >
            </p>
            <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
              <span style="font-family:微软雅黑; font-size:12pt">&nbsp;</span>
            </p>
          </div>
        </div>
      </div>
      <div class="agree-btn">
        <a-form :form="form">
          <a-form-item>
            <a-checkbox
              @change="checkAgree"
              v-decorator="[
                'agree',
                {
                  valuePropName: 'checked',
                  initialValue: true
                }
              ]">
              <span class="agreement" style=" ">
                本人确认已仔细阅读并充分理解
                <a-button @click="activeAgree = 1" style="padding: 0" type="link">《用户协议》</a-button>
                与<a-button @click="activeAgree = 2" style="padding: 0" type="link">《隐私协议》</a-button>
                的全部内容，同意接受上述协议的全部内容</span>
            </a-checkbox>
          </a-form-item>
        </a-form>
        <a-button
          :disabled="!agree.status || !agree.check"
          type="primary"
          @click="handleSubmit"
          class="login-form-button"
          style="width: 330px;height: 50px;border-radius:8px;margin:0px auto 16px">

          {{ agree.status?'同意':`${agree.time}s` }}
        </a-button>
      </div>
    </a-modal>
  </div>
</template>
<script>
export default {
  components: { },
  data () {
    return {
      exe1: false,
      exe2: false,
      timer: null,
      agreeTimer: null,
      codeState: {
        isSend: false,
        time: 60,
        status: 'success',
        errorText: ''
      },
      showAgree: false,
      form: this.$form.createForm(this),
      activeAgree: 1,
      agree: {
        time: 5,
        status: false,
        check: true
      }
    }
  },
  beforeCreate () {

  },
  mounted () {
    this.burry('5')
  },
  methods: {
    handleSubmit (e) {
      e.preventDefault()
      this.form.validateFields(async (err, values) => {
        if (!err) {
          this.burry('7')
          this.showAgree = false
          const { phone, psd, confirm_password, code } = values
          const res = await this.$api.user.register({ phone, password:psd, confirm_password, code, is_post: 1 })
          if (res.status === 'error') {
            if (res.message.key === 1007) {
              this.form.setFields({
                code: {
                  errors: [new Error('*验证码错误')]
                }
              })
            } else if (res.message.key === 1010) {
              this.form.setFields({
                phone: {
                  errors: [new Error(`*${res.message.message}`)]
                }
              })
            }
          } else {
            this.burry('6')
            this.$message.success('注册成功！请直接登录')
            this.$router.push({
              path: '/user/login'
            })
          }
        }
      })
    },
    checkForm () {
      this.burry('4')
      this.form.validateFields(async (err, values) => {
        if (!err) {
          const { phone, psd, confirm_password, code } = values
          const res = await this.$api.user.register({ phone, password:psd, confirm_password, code, is_post: 0 })
          if (res.status === 'error') {
            if (res.message.key === 1007) {
              this.form.setFields({
                code: {
                  errors: [new Error('*验证码错误')]
                }
              })
            } else if (res.message.key === 1010) {
              this.form.setFields({
                phone: {
                  errors: [new Error(`*${res.message.message}`)]
                }
              })
            }
          } else {
            this.showAgree = true
            this.agreeTimer = setInterval(() => {
              this.agree.time -= 1
              if (this.agree.time === 0) {
                this.agree.status = true
                this.agree.time = 5
                clearInterval(this.agreeTimer)
              }
            }, 1000)
          }
        }
      })
    },
    checkAgree (e) {
      console.log(e)
      this.agree.check = e.target.checked
    },
    passwordChange (e) {

    },
    getCode () {
      this.form.validateFields(['phone'], (error, value) => {
        if (error || this.codeState.isSend) {
          return false
        }
        const params = {
          phone: value.phone,
          type: 1 // 1普通验证码  2注销验证码
        }

        this.$api.user.getVerifyCode(params).then(res => {
          if (res.status === 'ok') {
            this.codeState.isSend = true
            this.timer = setInterval(() => {
              this.codeState.time -= 1
              if (this.codeState.time === 0) {
                this.codeState.time = 60
                this.codeState.isSend = false
                clearInterval(this.timer)
              }
            }, 1000)
          } else {
            if (res.message.key === 1006) { // 验证发送超过5次 弹出滑动验证码
              window.tncode.show()
              window.tncode.onSendResult((tn_check, key) => {
                console.log(tn_check, key)
                this.$api.user.getVerifyCode(Object.assign(params, { tn_check, key })).then(res => {
                  if (res.status === 'ok') {
                    this.$message.success('发送成功')
                    this.codeState.isSend = true
                    this.timer = setInterval(() => {
                      this.codeState.time -= 1
                      if (this.codeState.time === 0) {
                        this.codeState.time = 60
                        this.codeState.isSend = false
                        clearInterval(this.timer)
                      }
                    }, 1000)
                    window.tncode.hide()
                  } else {
                    window.tncode._showmsg(res.message.message)
                    // window.tncode.hide()
                  }
                })
              })
            } else if (res.message.key === 10000) { // 其它错误

            } else {

            }
          }
        })
      })
    },
    compareToFirstPassword (rule, value, callback) {
      const form = this.form
      if (value && value !== form.getFieldValue('psd')) {
        callback(new Error('与上方密码不同'))
      } else {
        callback()
      }
    },
    goLogin () {
      this.$router.push({
        path: '/user/login'
      })
    },
    checkRegister (rule, value, callback) {
      if (!value) {
        callback()
        return false
      }
      const params = {
        phone: value
      }
      this.$api.user.checkRegister(params).then(res => {
        if (res.status === 'ok') {
          if (res.data.result === 1) {
            callback(new Error('该手机号码已经被注册'))
          } else {
            callback()
          }
        } else {
          callback()
        }
      })
    },
    closeAgree () {
      this.agree.check = true
    }
  }
}
</script>

<style lang="less" scoped>

#components-form-demo-normal-login .login-form {
  max-width: 300px;
}
#components-form-demo-normal-login .login-form-forgot {
  float: right;
}
#components-form-demo-normal-login .login-form-button {
  width: 100%;
}
#login {
  position: relative;
  width: 100%;
  min-height: 100%;
  background: #f0f2f5 url(../../assets/img/bg.jpg) no-repeat 50%;
  background-size: 100%;
    background-position-y: 1px;
}

.container {
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  .loginBox {
    width: 460px;
    padding-bottom: 50px;
    background-color: #ffffff;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    border-radius: 20px;
    /deep/
    .ant-form-item-control-wrapper {
        .ant-form-item-children{
          padding-left: 0px;
        }
    }
    /deep/
    .ant-input-affix-wrapper .ant-input {
      height: 42px;
      border-radius: 8px;
    }
    /deep/
    .ant-form-explain{
      margin: 6px 0 12px;
    }
    h1 {
      margin-bottom: 60px;
    }
    /deep/
    .ant-checkbox + span {
      display: inline-block;
      vertical-align: -6px;
    }
    .agreement {
        font-size:12px;color:#999999; width:288px;display:inline-block;line-height:24px;
        vertical-align: top;
    }
    .logo {
      width: 200px;
      height: 70px;
      margin-bottom: 40px;
      background-color:  @primary-color;
      border-radius: 0px 0px 20px 20px;
      display: flex;
      justify-content: center;
      align-items: center;
      img {
        display: block;
        width: 142px;
        height: 25px;

      }
    }
    .reg-box {
      display: flex;
      justify-content: space-between;
      margin-bottom: 25px;
      a {
        color: inherit;
      }
      span {
        font-size: 14px;
        cursor: pointer;
        &:hover{
          color: @primary-color;
        }
      }
    }
    .login-form {
      width: 320px;
      /deep/
      .ant-checkbox-checked .ant-checkbox-inner {
        background: none;
      }
      /deep/
      .ant-checkbox-checked .ant-checkbox-inner::after {
        border-color: @primary-color;
      }
    }
  }
}

.title {
  font-family: 'Quicksand', 'Source Sans Pro', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue',
    Arial, sans-serif;
  display: block;
  font-weight: 300;
  font-size: 100px;
  color: #35495e;
  letter-spacing: 1px;
}

.subtitle {
  font-weight: 300;
  font-size: 42px;
  color: #526488;
  word-spacing: 5px;
  padding-bottom: 15px;
}

.links {
  padding-top: 15px;
}

.ant-modal-body {
  padding: 0 24px;
}
.agree-modal {
  .title {
    color: @primary-color;
    text-align: center;
    font-size: 24px;
  }

  .ant-modal-body{
    padding: 0 24px;
  }
  .agree-content {
    padding: 0 24px;
    height: 512px;
    overflow: auto;
    margin-bottom: 25px;

  }
  .agree-btn{

    text-align:center
  }
}

  .email-word {
    margin: 0 4px;
    display: inline-block;
    mask: url(../../assets/img/email.png) center / 100% no-repeat;
  }
</style>
